import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { NonTurningInventoryComponent } from '../inventory/non-turning-inventory/non-turning-inventory.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ReportsComponent } from '../reports/reports.component';
import { ReportViewComponent } from '../reports/report-view/report-view.component';
import { CustomerCreditCardsReportComponent } from '../reports/customer-credit-cards-report/customer-credit-cards-report.component';
import { RecurringReplenishmentComponent } from '../reports/recurring-replenishment/recurring-replenishment.component';
import { PromoIntroComponent } from '../reports/promo-intro/promo-intro.component';
import { BrandSalesRankingComponent } from '../reports/brand-sales-ranking/brand-sales-ranking.component';
import { AuthGuardService as AuthGuard } from '../auth/auth-guard.service'

//vustomers
import { CustomersComponent } from '../customers/customers.component';
import { CustomersGroupsComponent } from '../customers/customers-groups/customers-groups.component'
import { CustomerDashboardComponent } from '../customers/customer-dashboard/customer-dashboard.component';
import { CrptComponent } from '../customers/crpt/crpt.component';
import { CommissionSalesReportComponent } from '../customers/commission-sales-report/commission-sales-report.component';
import { SalesmanTerritoryReportComponent } from '../customers/salesman-territory-report/salesman-territory-report.component';
import { SalesRouteBuilderComponent } from '../customers/sales-route-builder/sales-route-builder.component';
import { SalesRouteRunnerComponent } from '../customers/sales-route-builder/route-runner/sales-route-runner.component';
import { RewardPointsComponent } from '../customers/reward-points/reward-points.component';
import { CsrptComponent } from '../customers/csrpt/csrpt.component';
import { CustomerItemHistoryComponent } from '../customers/customer-item-history/customer-item-history.component';
import { CustomerMonthlyHistoryComponent } from '../customers/customer-monthly-history/customer-monthly-history.component';
import { CustomerCdetComponent } from '../customers/customer-cdet/customer-cdet.component';
import { CustomerReportsComponent } from '../customers/customer-reports/customer-reports.component';
import { CustomerPaymentsReportComponent } from '../customers/customer-payments-report/customer-payments-report.component';

import { CpslsComponent } from '../customers/cpsls/cpsls.component';

import { CvslsComponent } from '../customers/cvsls/cvsls.component';
import { CustomerCpdetComponent } from '../customers/customer-cpdet/customer-cpdet.component';
import { ViewComponent } from '../customers/view/view.component';
import { CustomerOrdersComponent } from '../customers/customer-orders/customer-orders.component';
import { CustomerEditComponent } from '../customers/edit/customer-edit/customer-edit.component';
import { CustomerExportComponent } from '../customers/customer-export/customer-export.component';
import { RepBulkEnableComponent } from '../customers/rep-bulk-enable/rep-bulk-enable.component';
import { CustomerVehiclesComponent } from '../customers/customer-vehicles/customer-vehicles.component';
import { ConsignmentEditComponent } from '../customers/consignment-edit/consignment-edit.component';
//oe


import { LogoutComponent } from '../auth/logout/logout.component';
//import { OrdersComponent } from '../orders/orders.component';
import { OrderLookupComponent } from '../orders/order-lookup/order-lookup.component';
import { OrderSuccessComponent } from '../orders/order-entry/order-success/order-success.component';
import { OrdersDashboardComponent } from '../orders/orders-dashboard/orders-dashboard.component';
import { OrderConfirmationComponent } from '../orders/order-confirmation/order-confirmation.component';
import { OrderInquiryComponent } from '../orders/order-inquiry/order-inquiry.component';
import { BatchInvoicePrintComponent } from '../orders/batch-invoice-print/batch-invoice-print.component';
import { OrderItemInquiryComponent } from '../orders/order-item-inquiry/order-item-inquiry.component';
// import { OrderTrackingComponent } from 'app/orders/order-tracking/order-tracking.component';
import { OrderTrackingComponent } from 'app/shared/order-tracking/order-tracking.component';
import { SimpletireOrderProcessingComponent } from 'app/shared/simpletire-order-processing/simpletire-order-processing.component';

import { SingleItemTransferComponent } from 'app/shared/single-item-transfer/single-item-transfer.component';

import { OrdersOpenQuotesComponent } from '../orders/orders-open-quotes/orders-open-quotes.component';
import { ProductlineReportComponent } from '../orders/productline-report/productline-report.component';
import { ChannelreportsComponent } from '../orders/channelreports/channelreports.component';
import { ChannelordersComponent } from '../orders/channelorders/channelorders.component';
import { EmailIntakeComponent } from '../orders/email-intake/email-intake.component';


//import { OrderManagementComponent } from '../orders/order-management/order-management.component';
import { VendorsComponent } from '../vendors/vendors.component';
import { VendorItemsComponent } from '../vendors/vendor-items/vendor-items.component';
import { VendorEditComponent } from '../vendors/edit/vendor-edit/vendor-edit.component';
import { VendorCreateComponent } from '../vendors/vendor-create/vendor-create.component';
import { VendorViewComponent } from '../vendors/vendor-view/vendor-view.component';
import { VendorInvoiceComponent } from '../vendors/vendor-invoice/vendor-invoice.component';
import { VendorsDashboardComponent } from '../vendors/vendors-dashboard/vendors-dashboard.component';
import { VendorAllocationsComponent } from '../vendors/vendor-allocations/vendor-allocations.component'
import { VrptComponent } from '../vendors/vrpt/vrpt.component';
import { CheckPrintingComponent } from '../vendors/check-printing/check-printing.component';
import { PendingPaymentRunsComponent } from '../vendors/pending-payment-runs/pending-payment-runs.component';
import { PaymentRunReviewComponent } from '../vendors/payment-run-review/payment-run-review.component';
import { PaymentRunReportComponent } from '../vendors/payment-run-report/payment-run-report.component';
import { VendorDailyTransactionsComponent } from '../vendors/vendor-daily-transactions/vendor-daily-transactions.component';
import { VendorPaymentReportComponent } from '../vendors/vendor-payment-report/vendor-payment-report.component';
import { VendorPaymentRemittanceComponent } from '../vendors/vendor-payment-remittance/vendor-payment-remittance.component';
import { OpenPayablesComponent } from '../vendors/open-payables/open-payables.component';

import { VendorInvoiceCompleteComponent } from '../vendors/vendor-invoice/vendor-invoice-complete/vendor-invoice-complete.component';

import { RouteBuilderComponent } from '../orders/route-builder/route-builder.component';

import { DispatchesRouteBuilderComponent } from '../dispatches/dispatches-route-builder/dispatches-route-builder.component';
import { DispatchesDashboardComponent } from '../dispatches/dispatches-dashboard/dispatches-dashboard.component';

import { DispatchesLoadPriorityComponent } from '../dispatches/dispatches-load-priority/dispatches-load-priority.component';


import { DispatchesActiveDispatchComponent } from '../dispatches/dispatches-active-dispatch/dispatches-active-dispatch.component';

import { DispatchesLoadSheetComponent } from '../dispatches/dispatches-load-sheet/dispatches-load-sheet.component';

import { OrderPickComponent } from '../orders/order-pick/order-pick.component';

import { OrderCheckComponent } from '../orders/order-check/order-check.component';

import { AdrsComponent } from '../orders/adrs/adrs.component';
import { OrderOpenlistComponent } from '../orders/order-openlist/order-openlist.component';
import { OrderLoadComponent } from '../orders/order-load/order-load.component';
//import { OrderInvoiceComponent } from '../orders/order-entry/order-invoice/order-invoice.component';
import { OrderDispatchComponent } from '../orders/order-entry/order-dispatch/order-dispatch.component';

import { OrderReprintPickComponent } from '../orders/order-reprint-pick/order-reprint-pick.component'

import { TimelineComponent } from '../orders/timeline/timeline.component';
import { CustomerSearchComponent } from '../orders/customer-search/customer-search.component';
import { OrderEntryComponent } from '../orders/order-entry/order-entry.component'


//import { PickComponent } from '../orders/pick/pick.component';
import { DispatchesComponent } from '../dispatches/dispatches.component';
import { DispatchesDriverRunComponent } from '../dispatches/dispatches-driver-run/dispatches-driver-run.component';
import { DispatchesDeliveredNotinvoicedComponent } from '../dispatches/dispatches-delivered-notinvoiced/dispatches-delivered-notinvoiced.component';
import { DispatchesMaintanceComponent } from '../dispatches/dispatches-maintance/dispatches-maintance.component';
import { DispatchesRouteMaintanceComponent } from '../dispatches/dispatches-route-maintance/dispatches-route-maintance.component';
import { DispatchesDispatchReportComponent } from '../dispatches/dispatches-dispatch-report/dispatches-dispatch-report.component';



import { InventoryComponent } from '../inventory/inventory.component';
import { InventoryDashboardComponent } from '../inventory/inventory-dashboard/inventory-dashboard.component';
import { InventoryListComponent } from '../inventory/inventory-list/inventory-list.component';
import { SpecialPricingComponent } from '../inventory/special-pricing/special-pricing.component';
import { CommissionsComponent } from '../inventory/commissions/commissions.component';
import { InventoryTransfersComponent } from '../inventory/inventory-transfers/inventory-transfers.component';
import { InventoryPromosComponent } from '../inventory/inventory-promos/inventory-promos.component';

import { BranchReorderComponent } from '../inventory/branch-reorder/branch-reorder.component';
import { WeeklyReorderComponent } from '../inventory/weekly-reorder/weekly-reorder.component';
import { ClassicReorderComponent } from '../inventory/classic-reorder/classic-reorder.component';

import { WarehouseBinsComponent } from '../warehouse/warehouse-bins/warehouse-bins.component'
import { WarehouseDashboardComponent } from '../warehouse/warehouse-dashboard/warehouse-dashboard.component'
import { WarehouseItemReceivingComponent } from '../warehouse/warehouse-item-receiving/warehouse-item-receiving.component'
import { WarehouseItemScanComponent } from '../warehouse/warehouse-item-scan/warehouse-item-scan.component'
import { WarehouseItemScanTwoComponent } from '../warehouse/warehouse-item-scan-two/warehouse-item-scan-two.component'
import { WarehouseItemScanLiteComponent } from '../warehouse/warehouse-item-scan-lite/warehouse-item-scan-lite.component'
import { BarcodeGeneratorComponent } from '../warehouse/barcode-generator/barcode-generator.component'
import { WarehouseItemLookupComponent } from '../warehouse/warehouse-item-lookup/warehouse-item-lookup.component'

import { WarehouseStockCountsComponent } from '../warehouse/warehouse-stock-counts/warehouse-stock-counts.component'
import { WarehouseStockcountsScanComponent } from 'app/warehouse/warehouse-stockcounts-scan/warehouse-stockcounts-scan.component';


import { WarehouseVisitsComponent } from '../warehouse/warehouse-visits/warehouse-visits.component';
import { DeliveryBoardComponent } from '../warehouse/delivery-board/delivery-board.component'
import { PickBoardComponent } from '../warehouse/pick-board/pick-board.component'
import { PickStationComponent } from '../warehouse/pick-station/pick-station.component'

import { QantelItemSearchComponent } from '../qantel/qantel-item-search/qantel-item-search.component'
import { QantelOrderDashComponent } from '../qantel/qantel-order-dash/qantel-order-dash.component';
import { OdsComponent } from '../ods/ods.component';

//purchasing
import { PurchaseCreateComponent } from '../purchasing/purchase-create/purchase-create.component';
import { PurchaseOrderEntryComponent } from '../purchasing/purchase-order-entry/purchase-order-entry.component';
import { PurchasingSuccessComponent } from '../purchasing/purchasing-success/purchasing-success.component';
import { PurchasingDashboardComponent } from '../purchasing/purchasing-dashboard/purchasing-dashboard.component';
import { PurchaseOrderReceiveComponent } from '../purchasing/purchase-order-receive/purchase-order-receive.component'
import { RgaReturnComponent } from '../purchasing/rga-return/rga-return.component'

import { PurchaseOrderInquiryComponent } from '../purchasing/purchase-order-inquiry/purchase-order-inquiry.component'


import { PurchasingReceiptjournalComponent } from '../purchasing/purchasing-receiptjournal/purchasing-receiptjournal.component';

import { PurchaseOrderViewComponent } from '../purchasing/purchase-order-view/purchase-order-view.component';

import { PurchasingReceiptjournaluploadComponent } from '../purchasing/purchasing-receiptjournalupload/purchasing-receiptjournalupload.component';
import { PurchasingReorderingRestockComponent } from '../purchasing/purchasing-reordering/purchasing-reordering-restock/purchasing-reordering-restock.component';
import { PurchasingReorderingAvgsalesComponent } from '../purchasing/purchasing-reordering/purchasing-reordering-avgsales/purchasing-reordering-avgsales.component';
import { PurchasingReorderingMinmaxComponent } from '../purchasing/purchasing-reordering/purchasing-reordering-minmax/purchasing-reordering-minmax.component';
import { PurchasingBrandPriorityComponent } from '../purchasing/purchasing-brand-priority/purchasing-brand-priority.component';
import { PurchasingReorderingComponent } from '../purchasing/purchasing-reordering/purchasing-reordering.component';


import { CustomerCreateComponent } from '../customers/customer-create/customer-create.component';

import { InventoryViewComponent } from '../inventory/inventory-view/inventory-view.component';

import { InventoryCreateComponent } from '../inventory/inventory-create/inventory-create.component';
import { InventoryValueComponent } from '../inventory/inventory-value/inventory-value.component';


import { CompanySetupComponent } from '../system/company-setup/company-setup.component';
import { MarketingComponent } from '../system/marketing/marketing.component';
import { InventoryLocationsComponent } from '../system/inventory-locations/inventory-locations.component';
import { InventorySettingsComponent } from '../system/inventory-settings/inventory-settings.component';
import { StorefrontSettingsComponent } from '../system/storefront-settings/storefront-settings.component';
import { StorefrontLayoutComponent } from '../system/storefront-settings/storefront-layout/storefront-layout.component';
import { BannersComponent } from '../system/storefront-settings/banners/banners.component';
import { CategoriesComponent } from '../system/storefront-settings/categories/categories.component';
import { CustomerApprovalComponent } from '../system/storefront-settings/customer-approval/customer-approval.component';
import { InformationComponent } from '../system/storefront-settings/information/information.component';
import { QrCodesComponent } from '../system/storefront-settings/qr-codes/qr-codes.component';
import { BestsellersComponent } from '../system/storefront-settings/bestsellers/bestsellers.component';

import { InventoryLocationsCreateComponent } from '../system/inventory-locations/inventory-locations-create/inventory-locations-create.component';
import { GlAccountsComponent } from '../system/gl-accounts/gl-accounts.component'
import { CustomerGroupsComponent } from '../system/customer-groups/customer-groups.component'
import { ProductGroupsComponent } from '../system/product-groups/product-groups.component'
import { AccountSectionsComponent } from '../system/gl-accounts/account-sections/account-sections.component';
import { AccountGroupsComponent } from '../system/gl-accounts/account-groups/account-groups.component';

import { CouponSetupComponent } from '../system/coupon-setup/coupon-setup.component';


import { MailComponent } from '../system/mail/mail.component';

import { PaymentEntryComponent } from '../receivables/payment-entry/payment-entry.component'
import { CreditMemoIntakeComponent } from '../receivables/credit-memo-intake/credit-memo-intake.component'
import { ReceivablesByshipviaComponent } from '../receivables/receivables-byshipvia/receivables-byshipvia.component'

import { DailyTransactionsComponent } from '../receivables/daily-transactions/daily-transactions.component'
import { DriComponent } from '../receivables/dri/dri.component'

import { JournalReportComponent } from '../receivables/journal-report/journal-report.component'


import { ReceivablesAllocationsComponent } from '../receivables/receivables-allocations/receivables-allocations.component'
import { ReceivablesDashboardComponent } from '../receivables/receivables-dashboard/receivables-dashboard.component'
import { ArInterestInvoicesComponent } from '../receivables/ar-interest-invoices/ar-interest-invoices.component'
import { CollectionTrackerComponent } from '../receivables/collection-tracker/collection-tracker.component'
import { SrptComponent } from '../receivables/srpt/srpt.component';
import { BrandReportComponent } from '../receivables/brand-report/brand-report.component';



import { StatementsComponent } from '../receivables/statements/statements.component'
import { DayendCheckoutComponent } from '../receivables/dayend-checkout/dayend-checkout.component'
import { RsiComponent } from '../receivables/rsi/rsi.component'
import { VendorBackedRemittanceComponent } from '../receivables/vendor-backed-remittance/vendor-backed-remittance.component'
import { VendorBackedBalancesComponent } from '../receivables/vendor-backed-balances/vendor-backed-balances.component'
import { VendorBackedPaymentsComponent } from '../reports/vendor-backed-payments/vendor-backed-payments.component'
import { DregComponent } from '../receivables/dreg/dreg.component'

import { PaymentReportComponent } from '../receivables/payment-report/payment-report.component'
import { PosSalesReportComponent } from '../receivables/pos-sales-report/pos-sales-report.component'
import { BatchDashboardComponent } from '../receivables/payment-terms-batch/batch-dashboard.component'

import { UsersComponent } from '../users/users.component'
import { UserEditComponent } from '../users/user-edit/user-edit.component'
import { UserProfileComponent } from '../users/user-profile/user-profile.component'
import { UserSettingsComponent } from '../users/user-settings/user-settings.component'
import { UserCreateComponent } from '../users/user-create/user-create.component'
import { SalesmanAppUsersComponent } from '../users/salesman-app-users/salesman-app-users.component'
import { VendorsComponent as UsersVendorsComponent } from '../users/vendors/vendors.component'
import { FavoritesComponent } from '../users/favorites/favorites.component'

import { UserGroupsComponent } from '../users/user-groups/user-groups.component'
import { UserGroupsEditComponent } from '../users/user-groups-edit/user-groups-edit.component'

import { PermissionComponent } from '../auth/permission/permission.component';

import { ApiSettingsComponent } from '../system/api-settings/api-settings.component';
import { Tpl3plLayoutComponent } from '../system/tpl3pl/tpl3pl-layout/tpl3pl-layout.component';
import { Tpl3plConfigFormComponent } from '../system/tpl3pl/tpl3pl-config-form/tpl3pl-config-form.component';
import { Tpl3plExportQueueComponent } from '../system/tpl3pl/tpl3pl-export-queue/tpl3pl-export-queue.component';
import { Tpl3plInboundComponent } from '../system/tpl3pl/tpl3pl-inbound/tpl3pl-inbound.component';
import { Tpl3plShipmentsComponent } from '../system/tpl3pl/tpl3pl-shipments/tpl3pl-shipments.component';
import { Tpl3plOpenOrdersComponent } from '../system/tpl3pl/tpl3pl-open-orders/tpl3pl-open-orders.component';
import { Tpl3plInventoryComponent } from '../system/tpl3pl/tpl3pl-inventory/tpl3pl-inventory.component';
import { Tpl3plManualSkuPushComponent } from '../system/tpl3pl/tpl3pl-manual-sku-push/tpl3pl-manual-sku-push.component';
import { Tpl3plLogsComponent } from '../system/tpl3pl/tpl3pl-logs/tpl3pl-logs.component';
import { Tpl3plDashboardComponent } from '../system/tpl3pl/tpl3pl-dashboard/tpl3pl-dashboard.component';
import { Tpl3plCaptureAuthsComponent } from '../system/tpl3pl/tpl3pl-capture-auths/tpl3pl-capture-auths.component';
import { Tpl3plVoidAuthsComponent } from '../system/tpl3pl/tpl3pl-void-auths/tpl3pl-void-auths.component';
import { SystemTypesViewComponent } from '../system/system-types-view/system-types-view.component';
import { StatusMaintenanceComponent } from '../system/status-maintenance/status-maintenance.component';

import { MergeCustomersComponent } from '../system/merge-customers/merge-customers.component';
import { MatrixCopyComponent } from '../system/matrix-copy/matrix-copy.component';
import { MatrixBrandsComponent } from '../system/matrix-brands/matrix-brands.component';
import { BrandStorefrontsComponent } from '../system/brand-storefronts/brand-storefronts.component';
import { MoveTransactionComponent } from '../system/move-transaction/move-transaction.component';
import { MoveVendorTransactionComponent } from '../system/move-vendor-transaction/move-vendor-transaction.component';
import { ReportBuilderComponent } from '../system/report-builder/report-builder.component';
import { SaleBuilderComponent } from '../system/sale-builder/sale-builder.component';
import { TaxesComponent } from '../system/taxes/taxes.component';
import { CurrenciesComponent } from '../system/currencies/currencies.component';
import { BankAccountsComponent } from '../system/bank-accounts/bank-accounts.component';
import { SystemNoticeComponent } from '../system/system-notice/system-notice.component';

import { CreditFreestandingComponent } from '../credits/credit-freestanding/credit-freestanding.component'

import { CreditSuccessComponent } from '../credits/credit-success/credit-success.component'
import { SuccessComponent } from '../credits/success/success.component'
import { CreditReceiveComponent } from '../credits/credit-receive/credit-receive.component'
import { CreditLoadComponent } from '../credits/credit-load/credit-load.component'
import { OpenCreditListComponent } from '../credits/open-credit-list/open-credit-list.component'
import { RmaLogComponent } from '../credits/rma-log/rma-log.component'


import { CreditDispatchComponent } from '../credits/credit-dispatch/credit-dispatch.component'
import { FinalizeComponent } from '../credits/finalize/finalize.component'


import { FixedAssetsManagementComponent } from '../fixed-assets/fixed-assets-management/fixed-assets-management.component'

import { TrialBalanceComponent } from '../general-ledger/trial-balance/trial-balance.component'
import { SimpleTrialBalanceComponent } from '../general-ledger/simple-trial-balance/simple-trial-balance.component'
import { JournalInquiryComponent } from '../general-ledger/journal-inquiry/journal-inquiry.component'
import { GlBudgetsComponent } from '../general-ledger/gl-budgets/gl-budgets.component'
import { GLTagsComponent } from '../general-ledger/gl-tags/gl-tags.component'
import { SalesGLPostingsComponent } from '../general-ledger/sales-gl-postings/sales-gl-postings.component'
import { CogsGlPostingsComponent } from '../general-ledger/cogs-gl-postings/cogs-gl-postings.component'
import { InventoryGlPostingsComponent } from '../general-ledger/inventory-gl-postings/inventory-gl-postings.component'
import { GeneralPostingSetupComponent } from '../general-ledger/general-posting-setup/general-posting-setup.component'

//import { SalesTaxComponent } from '../general-ledger/sales-tax/sales-tax.component'

import { SalesTaxCompressedComponent } from '../general-ledger/sales-tax-compressed/sales-tax-compressed.component'
import { BeauticianProspectingComponent } from '../general-ledger/beautician-prospecting/beautician-prospecting.component'


import { AccountInquiryComponent } from '../general-ledger/account-inquiry/account-inquiry.component'
import { DocumentLookupComponent } from '../general-ledger/document-lookup/document-lookup.component'

import { ProfitLossComponent } from '../general-ledger/profit-loss/profit-loss.component'
import { ShieldComplianceComponent } from '../general-ledger/shield-compliance/shield-compliance.component'
import { ExpenseByDepartmentComponent } from '../general-ledger/expense-by-department/expense-by-department.component'
import { ThirdPartySalesGlReportComponent } from '../general-ledger/third-party-sales-gl-report/third-party-sales-gl-report.component'
import { TaxAuthorityReportComponent } from '../general-ledger/tax-authority-report/tax-authority-report.component'
import { BalanceSheetComponent } from '../general-ledger/balance-sheet/balance-sheet.component'
import { JournalEntryComponent } from '../general-ledger/journal-entry/journal-entry.component'
import { BankRecComponent } from '../general-ledger/bank-rec/bank-rec.component'
import { SalesLedgerControlCheckComponent } from '../general-ledger/sales-ledger-control-check/sales-ledger-control-check.component'
import { GlCloseControlComponent } from '../general-ledger/gl-close-control/gl-close-control.component'
import { GlDepartmentRequiredComponent } from '../general-ledger/gl-department-required/gl-department-required.component'
import { GlImpactViewComponent } from '../general-ledger/gl-impact-view/gl-impact-view.component'

//import { UsergroupsComponent} from '../usergroups/usergroups.component'

import { PurchasingOpenOrdersComponent } from '../purchasing/purchasing-open-orders/purchasing-open-orders.component';
import { PurchasingOpenGrnsComponent } from '../purchasing/purchasing-open-grns/purchasing-open-grns.component';
import { CounterPosComponent } from '../counter-pos/counter-pos/counter-pos.component'
import { CounterPosInvoiceComponent } from '../counter-pos/counter-pos-invoice/counter-pos-invoice.component'
import { CounterPosDashboardComponent } from '../counter-pos/counter-pos-dashboard/counter-pos-dashboard.component'
import { ItemQueryComponent } from '../counter-pos/item-query/item-query.component'
import { PosReceiptComponent } from '../counter-pos/pos-receipt/pos-receipt.component'


import { WarehouseFinalizerecComponent } from '../warehouse/warehouse-finalizerec/warehouse-finalizerec.component';

import { ArchiveListComponent } from '../archive/archive-list/archive-list.component';
import { WarehouseReportsComponent } from '../warehouse/warehouse-reports/warehouse-reports.component';

import { WarehouseCheckingComponent } from '../warehouse/warehouse-checking/warehouse-checking.component';
import { IdetReportComponent } from '../shared/idet-report/idet-report.component';
import { SalesDashboardComponent } from '../shared/sales-dashboard/sales-dashboard.component';
import { CustomerItemProdlineSalesComponent } from '../shared/customer-item-prodline-sales/customer-item-prodline-sales.component';
import { TopHundredComponent } from '../shared/top-hundred/top-hundred.component';
import { SpslsComponent } from '../orders/spsls/spsls.component';
import { ShippingMethodsComponent } from '../system/shipping-methods/shipping-methods.component';
import { SalesAreasComponent } from '../system/sales-areas/sales-areas.component';

import { InventoryUploadComponent } from '../inventory/inventory-upload/inventory-upload.component';
import { XrefCostUploadComponent } from '../inventory/xref-cost-upload/xref-cost-upload.component';
import { BatchCostUpdateComponent } from '../inventory/batch-cost-update/batch-cost-update.component';
import { CidReportComponent } from '../shared/cid-report/cid-report.component';

import { EducationEventsComponent } from '../education/education-events/education-events.component';
import { EducationLocationsComponent } from '../education/education-locations/education-locations.component';
import { EducationRewardsComponent } from '../education/education-rewards/education-rewards.component';
import { EducationNumbersComponent } from '../education/education-numbers/education-numbers.component';
import { AttendeesComponent } from '../education/attendees/attendees.component';
import { VoucherReportComponent } from '../education/voucher-report/voucher-report.component';
import { JpmsReportComponent } from '../shared/jpms-report/jpms-report.component';
import { ReportsPmmComponent } from '../shared/reports-pmm/reports-pmm.component';

import { PriceLevelPricingComponent } from '../customers/price-level-pricing/price-level-pricing.component';
import { BarcodeAssignerComponent } from '../shared/barcode-assigner/barcode-assigner.component';
import { FormBuilderComponent } from '../shared/form-builder/form-builder.component';
import { WarehouseCheckingFedexComponent } from 'app/warehouse/warehouse-checking-fedex/warehouse-checking-fedex.component';
import { StickerScanOutComponent } from 'app/warehouse/sticker-scan-out/sticker-scan-out.component';
import { StickerScanOutHistoryComponent } from 'app/warehouse/sticker-scan-out-history/sticker-scan-out-history.component';
import { StickerPaymentProcessingComponent } from 'app/warehouse/sticker-payment-processing/sticker-payment-processing.component';
import { DispatchDriverUnloadComponent } from '../dispatches/dispatch-driver-unload/dispatch-driver-unload.component';
import { WarehouseCheckingWifiComponent } from '../warehouse/warehouse-checking-wifi/warehouse-checking-wifi.component';

import { VehiclesMainComponent } from '../vehicles/vehicles-main/vehicles-main.component';

// import { DynamicDashboardComponent } from '../shared/dynamic-dashboard/dynamic-dashboard.component';
import { UserDashboardComponent } from 'app/dynamic-dashboard/user-dashboard/user-dashboard.component';
import { CanceledOrdersComponent } from 'app/shared/canceled-orders/canceled-orders.component';
import { SpiffReportComponent } from 'app/shared/spiff-report/spiff-report.component';
import { StickerFeedControlComponent } from 'app/shared/sticker-feed-control/sticker-feed-control.component';
import { NewItemsReportComponent } from 'app/shared/new-items-report/new-items-report.component';
import { OrderEntryLogComponent } from 'app/shared/order-entry-log/order-entry-log.component';

//import { ReportsService } from '../services/reports.service';


export interface RouteInfo {
	path: string;
	title: string;
	icon: string;
	class: string;
	/** Optional alias used by menu search matching (does not override displayed title). */
	label ? : string;
	/** Optional long title for display when different from title. */
	longtitle ? : string;
	children ? : any[];
	/** Submenu entries under "Reports"; optional bypassReportCatalog skips dynamic report catalog matching. */
	reports ? : any[];
	anchor ? : string;
	package ? : string;
	storefrontStandaloneOnly ? : boolean;
	hideWhenStorefrontStandalone ? : boolean;
	/** Hide this entry when env.client matches one of these tenant codes. */
	hideForClient ? : string[];
	/** Only show this entry for these specific tenant codes (env.client). */
	clientOnly ? : string[];
	/** Hide unless runtime config flag (e.g. config_rb2_enabled) is truthy. */
	requireConfigTruthy ? : string;
	/** When true, only show this child if the user's report catalog includes this title. */
	reportGated ? : boolean;
}

export function getItemId(path: string): string {
	if (!path) {return '';}
	return path.replace(/^\//, '');
}

// SIDE BAR DISPLAY

export const VERSION: any = { version: '1.1.2' }


export const ROUTES: RouteInfo[] = [

	{ path: '/dashboard', title: 'Dashboard', icon: 'dashboard', class: '' },
	//{ path: '/orders/entry/new', title: 'New Order', icon: 'launch', class: '' },
	{
		path: '/customers',
		title: 'Customers',
		icon: 'groups',
		class: '',
		anchor: 'customers',
		children: [{
			path: '/customers/dashboard',
			title: 'Customer Dashboard',
			icon: 'CD',
			class: '',
		},
		{
			path: '/customers',
			title: 'Customer Lookup',
			icon: 'CL',
			class: '',
		},
		{
			path: '/customers/reward-points',
			title: 'Customer Rewards',
			icon: 'CR',
			class: '',
		},
			//{
			//	path: '/customer/groups',
			//	title: 'Customer Groups',
			//	icon: 'CL',
			//	class: '',
			//},
		],
		reports: [		{
			path: '/customers/crpt',
			title: 'Customer Sales By Branch',
			icon: 'CRPT',
			class: '',
		},
		{
			path: '/customers/commission-sales',
			title: 'Commissioned Sales Report',
			icon: 'COM',
			class: '',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/salesman-territory',
			title: 'Salesman Territory Report (STRPT)',
			icon: 'STR',
			class: '',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/sales-route-builder',
			title: 'Sales Route Builder',
			icon: 'SRB',
			class: '',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/sales-route-runner',
			title: 'My Sales Route (Live)',
			icon: 'SRR',
			class: '',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/salon-prospects',
			title: 'Salon Prospects',
			icon: 'SP',
			class: '',
			package: 'beauty',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/csrpt',
			title: 'Customer Salesman Ranking',
			icon: 'CSRPT',
			class: '',
		},
		{
			path: '/customers/itemHistory',
			title: 'Customer Item History',
			icon: 'CIH',
			class: '',
		},
		{
			path: '/customers/monthlyHistory',
			title: 'Customer Monthly History',
			icon: 'CMH',
			class: '',
		},
		{
			path: '/customers/cdet',
			title: 'Customer Detail Report',
			icon: 'CDET',
			class: '',
		},
		{
			path: '/customers/cpsls',
			title: 'Customer PL Sales Report',
			longtitle: 'Customer Product Line Sales Report',
			icon: 'CPSLS',
			class: '',
		},
		{
			path: '/customers/customer-cpdet',
			title: 'Single Customer PL Sales Report',
			longtitle: 'Single Customer Product Line Sales Report',
			icon: 'CPDET',
			class: '',
		},
		{
			path: '/customers/customer-payments',
			title: 'Customer Payments',
			longtitle: 'Customer Payments & Allocations',
			icon: 'CPAY',
			class: '',
			bypassReportCatalog: true,
		},
		{
			path: '/customers/customer-export',
			title: 'Customer Export',
			longtitle: 'Customer Export',
			icon: 'CEXP',
			class: '',
		},

		]
	},
	{
		path: '/counter-pos',
		title: 'Counter POS',
		icon: 'point_of_sale',
		class: '',
		anchor: 'counter-pos',
		package: 'beauty',
		children: [
			// Dashboard and Core Operations
			{
				path: '/counter-pos-dashboard',
				title: 'POS Dashboard',
				icon: 'PD',
				class: '',
				anchor: 'counter-pos-dashboard'
			},
			{
				path: '/counter-pos',
				title: 'New Order',
				icon: 'OE',
				class: '',
				anchor: 'counter-daily-orderentry'
			},
			{
				path: '/counter-pos/openorders',
				title: 'Open Orders',
				icon: 'OO',
				class: '',
				anchor: 'orders-open-pos'
			},
			{
				path: '/counter-pos/create-credit-note',
				title: 'Create Credit',
				icon: 'CC',
				class: '',
				anchor: 'orders-create-credit-note-pos'
			},

			// Reports
			{
				path: '/counter-pos/daily-transactions',
				title: 'Daily Transactions',
				icon: 'DT',
				class: '',
				anchor: 'counter-daily-transactions'
			},
			{
				path: '/counter-pos/cid-report',
				title: 'Cust Item Sales Report',
				icon: 'CID',
				class: '',
				anchor: 'counter-cid-report'
			},
			{
				path: '/counter-pos/payment-report',
				title: 'Payment Report',
				icon: 'PR',
				class: '',
				anchor: 'counter-payments'
			},

			// Inventory and Reordering
			{
				path: '/inventory/weekly-reorder',
				title: 'Weekly Re-Ordering',
				icon: 'BR',
				class: '',
				package: ''
			},

			// Queries and Inquiries
			{
				path: '/counter-pos/iq',
				title: 'Item Query',
				icon: 'IQ',
				class: '',
				anchor: 'counter-pos-item-query'
			},
			{
				path: '/counter-pos/dri',
				title: 'Daily Receivables Inquiry',
				icon: 'DRI',
				class: '',
				anchor: 'dri'
			},
			{
				path: '/counter-pos/dreg',
				title: 'DREG',
				icon: 'DR',
				class: '',
				anchor: 'counter-dreg'
			},
			{
				path: '/counter-pos/stock-counts',
				title: 'Stock Counts',
				icon: 'SC',
				class: '',
				anchor: 'stock-counts'
			}
		]
	},

	{
		path: '/orders',
		title: 'Orders',
		icon: 'shopping_cart',
		class: '',
		anchor: 'sales',
		children: [
			/*{
					path: '/orders/qantel-dashboard',
					title: 'Q Order DashBoard',
					icon: 'QOD',
					class: '',
					anchor: 'orders-qantel-dashboard'
				},
				*/
			{
				path: '/orders/dashboard',
				title: 'Order DashBoard',
				icon: 'OD',
				class: '',
				anchor: 'orders-dashboard'
			},
			{
				path: '/orders/dynamic',
				title: 'Dynamic DashBoard',
				icon: 'ODD',
				class: '',
				anchor: 'dynamic-dashboard'
			},
			{
				path: '/orders/entry',
				title: 'Order Entry',
				icon: 'OE',
				class: '',
				anchor: 'orders-entry'
			},
			{
				path: '/orders/openorders',
				title: 'Open Orders',
				icon: 'OO',
				class: '',
				anchor: 'orders-open'
			},
			{
				path: '/orders/email-intake',
				title: 'Business mail intake',
				icon: 'BMI',
				class: '',
				anchor: 'orders-email-intake'
			},
			{
				path: '/orders/openquotes',
				title: 'Open Quotes',
				icon: 'OQ',
				class: '',
				anchor: 'orders-open-quotes'
			},
			{
				path: '/orders/canceledorders',
				title: 'Canceled Orders',
				icon: 'CO',
				class: '',
				anchor: 'canceled-orders'
			},
			// {
			// 	path: '/orders/spiffreport',
			// 	title: 'SPIFF Report',
			// 	icon: 'SR',
			// 	class: '',
			// 	anchor: 'spiff-report'
			// },
			{
				path: '/orders/create-credit-note',
				title: 'Create RMA',
				icon: 'CC',
				class: '',
				anchor: 'orders-create-credit-note'
			},
			{
				path: '/credits/open-credits',
				title: 'Open RMAs',
				icon: 'OC',
				class: '',
				anchor: 'open-credit-list'
			},
			{
				path: '/credits/rma-log',
				title: 'RMA Log',
				icon: 'RL',
				class: '',
				anchor: 'credits-rma-log'
			},
			{
				path: '/orders/order-inquiry',
				title: 'Order Inquiry',
				icon: 'OI',
				class: '',
				anchor: 'order-inquiry'
			},
			{
				path: '/orders/batch-invoice-print',
				title: 'Batch invoice PDF',
				icon: 'BIP',
				class: '',
				anchor: 'batch-invoice-print'
			},
			{
				path: '/orders/order-item-inquiry',
				title: 'Order Item Inquiry',
				icon: 'OII',
				class: '',
				anchor: 'order-item-inquiry'
			},
			{
				path: '/orders/order-tracking',
				title: 'Order tracking',
				icon: 'OT',
				class: '',
				anchor: 'order-tracking'
			},
			{
				path: '/orders/simpletire-orders',
				title: 'SimpleTire Orders',
				icon: 'STOO',
				class: '',
				anchor: 'simpletire-orders'
			},
			{
				path: '/orders/order-entry-log',
				title: 'Order Entry Log',
				icon: 'OEL',
				class: '',
				anchor: 'order-entry-log'
			},
			/*{
					path: '/orders/order-confirmation',
					title: 'Order Confirmation',
					icon: 'OC',
					class: '',
					anchor: 'order-confirmation'
				},

				{
					path: '/orders/reprintpick',
					title: 'Print Picking Lists',
					icon: 'PP',
					class: '',
					anchor: 'orders-reprintpick'
				},
				*/
		],
		reports: [{
			path: '/orders/productline-report',
			title: 'Productline Report',
			icon: 'PLR',
			class: '',
			anchor: 'productline-report'
		},
		{
			path: '/orders/spsls',
			title: 'Salesman Product Line Sales by Branch',
			icon: 'SPSLS',
			class: '',
		},
		{
			path: '/orders/jpms',
			title: 'JPMS',
			icon: 'JPMS',
			class: '',
		},
		{
			path: '/orders/spiff',
			title: 'SPIFF',
			icon: 'SPI',
			class: '',
		},
		{
			path: '/orders/pmm',
			title: 'PMM',
			icon: 'PMM',
			class: '',
		},
		{
			path: '/orders/channel-reports',
			title: 'Channel Reports',
			icon: 'CHR',
			class: '',
			anchor: 'orders-channel-reports',
		},
		{
			path: '/orders/channel-orders',
			title: 'Channel Orders',
			icon: 'CHO',
			class: '',
			anchor: 'orders-channel-orders',
		},
		{
			// bypassReportCatalog because this reads stockmoves directly rather than
			// being a catalog SQL report — there is no reports_access row for its
			// title to match, so without this the entry is invisible to everyone.
			// Access then falls back to the path, granted via IMPLIED_MENU_PATHS.
			path: '/orders/promo-intro',
			title: 'Promo & Intro',
			longtitle: 'Promo & Intro Performance',
			icon: 'PI',
			class: '',
			anchor: 'promo-intro',
			bypassReportCatalog: true,
		}, ]
	},
	{
		path: '/sales-manager-reports',
		title: 'Salesman Reports',
		icon: 'trending_up',
		class: '',
		anchor: 'sales-manager-reports',
		package: 'beauty',



		children: [{
			path: '/sales-manager-reports/dailytrans',
			title: 'Daily Transactions',
			icon: 'DT',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/crpt',
			title: 'Customer Sales By Branch',
			icon: 'CRPT',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/commission-sales',
			title: 'Commissioned Sales Report',
			icon: 'COM',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/salesman-territory',
			title: 'Salesman Territory Report (STRPT)',
			icon: 'STR',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/sales-route-builder',
			title: 'Sales Route Builder',
			icon: 'SRB',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/csrpt',
			title: 'Customer Salesman Ranking',
			icon: 'CSRPT',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/itemHistory',
			title: 'Customer Item History',
			icon: 'CIH',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/monthlyHistory',
			title: 'Customer Monthly History',
			icon: 'CMH',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/cdet',
			title: 'Customer Detail Report',
			icon: 'CDET',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/cpsls',
			title: 'Customer PL Sales Report',
			longtitle: 'Customer Product Line Sales Report',
			icon: 'CPSLS',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/customer-cpdet',
			title: 'Single Customer PL Sales Report',
			longtitle: 'Single Customer Product Line Sales Report',
			icon: 'CPDET',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/productline-report',
			title: 'Productline Report',
			icon: 'PLR',
			class: '',
			anchor: 'productline-report',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/spsls',
			title: 'Salesman Product Line Sales by Branch',
			icon: 'SPSLS',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/top-hundred',
			title: 'Top 100 Items',
			icon: '100',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/cid-report',
			title: 'Cust Item Sales Detail Report',
			icon: 'CID',
			class: '',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/cvsls',
			title: 'Vendor Product Customer Sales',
			longtitle: 'Vendor Product Customer Sales',
			icon: 'CVSLS',
			class: '',
			anchor: 'cvsls',
			package: 'beauty',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/vrpt',
			title: 'Vendor Sales by Branch',
			longtitle: 'VRPT - Vendor Sales by Branch',
			icon: 'VRPT',
			class: '',
			anchor: 'vrpt',
			// package: 'beauty',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/idet-report',
			title: 'IGR',
			longtitle: 'IDET',
			icon: 'IDET',
			class: '',
			anchor: 'IDET',
			reportGated: true,
		},
		{
			path: '/sales-manager-reports/sales-dashboard',
			title: 'Sales Dashboard',
			longtitle: 'Sales Dashboard',
			icon: 'SD',
			class: '',
			anchor: 'sales-dashboard',
			reportGated: true,
		},
		{
			// Not reportGated: the recurring snapshot is not a catalog SQL report,
			// so there is no grant row to match on and gating it would hide the
			// screen from everyone. Add a grant later if per-user control is wanted.
			path: '/sales-manager-reports/recurring-replenishment',
			title: 'Recurring Replenishment',
			longtitle: 'Recurring Replenishment',
			icon: 'RR',
			class: '',
			anchor: 'recurring-replenishment',
		},
		]
	},
	{
		path: '/vendors',
		title: 'Vendors',
		icon: 'contactless',
		class: '',
		anchor: 'payables',
		children: [
			{
				path: '/vendors-dashboard',
				title: 'Dashboard',
				icon: 'VD',
				class: '',
				anchor: 'vendors-dashboard'
			},
			{
				path: '/vendors',
				title: 'Vendor Lookup',
				icon: 'VL',
				class: '',
				anchor: 'vendors-lookup'
			},
			{
				// Same screen as Receivables → Vendor Intake; distinct path/anchor to avoid sidebar id collision.
				path: '/vendors/vendor-intake',
				title: 'Credit Memo Intake',
				icon: 'VI',
				class: '',
				anchor: 'vendors-vendor-intake'
			},
			{
				path: '/vendors-check-print',
				title: 'Payment run',
				icon: 'CP',
				class: '',
				anchor: 'vendors-check-print'
			},
			{
				path: '/vendors-pending-payment-runs',
				title: 'Pending payment runs',
				icon: 'PP',
				class: '',
				anchor: 'vendors-pending-payment-runs'
			},
			{
				path: '/vendor-allocations',
				title: 'Allocations',
				icon: 'A',
				class: '',
				anchor: 'vendor-allocations'
			},
			{
				path: '/vendors/daily-transactions',
				title: 'Daily Transactions',
				icon: 'DT',
				class: '',
				anchor: 'vendor-daily-transactions',
			},
			{
				path: '/paymentrun',
				title: 'Vendor Payment Run Report',
				icon: 'VPR',
				class: '',
				anchor: 'vpr',
			},
			{
				path: '/vendors/payment-report',
				title: 'Vendor Payment Report',
				icon: 'VPR',
				class: '',
				anchor: 'vendors-payment-report',
			},
			{
				path: '/vendors/payment-remittance',
				title: 'Remittance email',
				icon: 'RE',
				class: '',
				anchor: 'vendors-payment-remittance',
			}],
		reports: [
			{
				path: '/vendors/open-payables',
				title: 'Open Payables',
				longtitle: 'Open Payables - all vendors, by invoice date and due date',
				icon: 'OP',
				class: '',
				anchor: 'vendors-open-payables',
				// Reads supptrans directly rather than the report catalog.
				bypassReportCatalog: true,
			},
			{
				path: '/vendors/reports/vrpt',
				title: 'Vendor Sales by Branch',
				longtitle: 'VRPT - Vendor Sales by Branch',
				icon: 'VRPT',
				class: '',
				anchor: 'vrpt',
				// package: 'beauty',
			},
			{
				path: '/customers/cvsls',
				title: 'Vendor Product Customer Sales',
				longtitle: 'CVSLS - Vendor / Product / Customer Sales',
				icon: 'CVSLS',
				class: '',
				anchor: 'cvsls',
				package: 'beauty',
			}]
	},
	{
		path: '/warehouose',
		title: 'Warehouse',
		icon: 'domain',
		class: '',
		anchor: 'warehouse',
		children: [{
			path: '/warehouse/dashboard',
			title: 'Dashboard',
			icon: 'WD',
			class: '',
			anchor: 'warehouose-dashboard',
		},
		{
			path: '/warehouse/delivery-board',
			title: 'Incoming Shipments',
			icon: 'IS',
			class: '',
			anchor: 'delivery-board',
		},
		{
			path: '/warehouse/finalize-rec',
			title: 'Finalize Rec',
			icon: 'IS',
			class: '',
			anchor: 'finalize-rec',
		},
		{
			path: '/warehouse/item-lookup',
			title: 'Item Lookup',
			icon: 'IS',
			class: '',
			anchor: 'item-lookup',
		},
		{
			path: '/warehouse/item-scan-two',
			title: 'Scan Items',
			icon: 'SI',
			class: '',
			anchor: 'warehouse-item-scan-two',
		},
		{
			path: '/warehouse/item-scan-lite',
			title: 'Tire Scan Lite',
			icon: 'TSL',
			class: '',
			anchor: 'warehouse-item-scan-lite',
			package: 'tires',
		},
		// {
		// 	path: '/warehouse/item-scan',
		// 	title: 'Item Scan-**',
		// 	icon: 'IS',
		// 	class: '',
		// 	anchor: 'warehouse-item-scan',
		// },
		{
			path: '/warehouse/pick-station',
			title: 'Pick Station',
			icon: 'PS',
			class: '',
			anchor: 'warehouse-pick-station',
			hideForClient: ['moov'],
		},
		{
			path: '/warehouse/check-station',
			title: 'Check Station',
			icon: 'CS',
			class: '',
			anchor: 'warehouse-check-station',
			hideForClient: ['moov'],
		},
		{
			path: '/warehouse/pick-board',
			title: 'Pick Board',
			icon: 'PB',
			class: '',
			anchor: 'warehouse-pick-board',
			hideForClient: ['moov'],
		},
		{
			path: '/orders/pick',
			title: 'Picking',
			icon: 'P',
			class: '',
			anchor: 'warehouse-pick',
			// moov picks via METRC RFID scanning (separate flow); generic warehouse
			// picking screen would confuse pickers there. /metrc/picking is exposed
			// at the top level for moov via the entry below.
			hideForClient: ['moov'],
		},
		{
			path: '/metrc/picking',
			title: 'Picking',
			icon: 'P',
			class: '',
			anchor: 'metrc-picking-top',
			clientOnly: ['moov'],
		},
		{
			path: '/metrc/receiving',
			title: 'Receiving',
			icon: 'R',
			class: '',
			anchor: 'metrc-receiving-top',
			clientOnly: ['moov'],
		},
		{
			// The scheduler tables ship with the b2b portal's migration 083 and
			// exist on the moov databases only, so the entry is tenant-gated.
			path: '/warehouse/visits',
			title: 'Warehouse Visits',
			icon: 'WV',
			class: '',
			anchor: 'warehouse-visits',
			clientOnly: ['moov'],
		},
		{
			path: '/orders/check',
			title: 'Checking',
			icon: 'C',
			class: '',
			anchor: 'warehouse-check',
			package: 'beauty',

		},
		{
			path: '/warehouse/stock-counts',
			title: 'Stock Counts',
			icon: 'SC',
			class: '',
			anchor: 'warehouse-stock-counts',
		},
		{
			path: '/warehouse/stock-counts-scan',
			title: 'Stock Counts Scannable',
			icon: 'SCS',
			class: '',
			anchor: 'warehouse-stock-counts-scan',
		},
		/*
					{
						path: '/credit/picking',
						title: 'Credit Receiveing',
						icon: 'CR',
						class: '',
						anchor: 'credit-picking',
					},

					{
						path: '/warehouse/receive',
						title: 'Receiving',
						icon: 'PR',
						class: '',
						anchor: 'purchasing-receive'
					},
					*/
		{
			path: '/warehouse/bins',
			title: 'Bins',
			icon: 'BIN',
			class: '',
			anchor: 'warehouse-bins',
		},
		{
			path: '/warehouse/warehouse-reports',
			title: 'Warehouse Reports',
			icon: 'WHR',
			class: '',
			anchor: 'warehouse-reports'
		},
		{
			path: '/warehouse/warehouse-loading',
			title: 'Warehouse Loading',
			icon: 'WHR',
			class: '',
			anchor: 'warehouse-loading'
		},
		{
			path: '/warehouse/warehouse-loading-wifi',
			title: 'Warehouse Loading Wi-Fi',
			icon: 'WHR',
			class: '',
			anchor: 'warehouse-loading-wifi'
		},
		{
			path: '/warehouse/warehouse-loading-fedex',
			title: 'Warehouse Loading Fedex',
			icon: 'LDF',
			class: '',
			anchor: 'warehouse-loading-fedex'
		},
		{
			path: 'warehouse/sticker-scan-out',
			title: 'Sticker Scan Out',
			icon: 'SSO',
			class: '',
			anchor: 'sticker-scan-out'
		},
		{
			path: 'warehouse/sticker-scan-out-history',
			title: 'Sticker Scan Out History',
			icon: 'SOH',
			class: '',
			anchor: 'sticker-scan-out-history'
		},
		{
			path: '/warehouse/barcode-assigner',
			title: 'Barcode Assigner',
			icon: 'BCA',
			class: '',
			anchor: 'barcode-assigner'
		},
		{
			path: '/warehouse/barcode-generator',
			title: 'Barcode Generator',
			icon: 'BCG',
			class: '',
			anchor: 'barcode-generator'
		},


		]
	},
	{
		path: '/dispatches',
		title: 'Dispatch',
		icon: 'local_shipping',
		anchor: 'dispatching',
		class: '',
		children: [{
			path: '/dispatches/dashboard',
			title: 'DashBoard',
			icon: 'DD',
			class: '',
			anchor: 'disaptch-dashboard',
		},
		{
			path: '/dispatches/route-builder',
			title: 'Route-Builder',
			icon: 'RB',
			class: '',
			anchor: 'route-builder',
		},
		{
			path: '/route-builder-v2',
			title: 'Route Builder v2',
			icon: 'RB2',
			class: '',
			anchor: 'route-builder-v2',
			requireConfigTruthy: 'config_rb2_enabled',
		},
		{
			path: '/dispatches/load-sheet',
			title: 'Load Sheet',
			icon: 'LS',
			class: '',
			anchor: 'loading-sheet',
		},
		{
			path: '/dispatches/driver-unload',
			title: 'Unload Truck',
			icon: 'UT',
			class: '',
			anchor: 'driver-unload',
		},
		{
			path: '/dispatches/active',
			title: 'Active Dispatches',
			icon: 'AD',
			class: '',
			anchor: 'active-dispatches',
		},
		{
			path: '/dispatches/baypriority',
			title: 'Loading Bay Matienance',
			icon: 'LB',
			class: '',
			anchor: 'dispatch-priority',
		},
		/*{
						path: '/dispatches/drivers',
						title: 'Active Runs',
						icon: 'AR',
						class: '',
						anchor: 'active-runs',
					},
					*/
		{
			path: '/dispatches/deliverednotinvoiced',
			title: 'Order Confirmation',
			icon: 'OC',
			class: '',
			anchor: 'active-deliverednotinvoiced',
		},
		{
			path: '/dispatches/open-credits',
			title: 'RMAS',
			icon: 'RMA',
			class: '',
			anchor: 'credits-dispatches-credits',
		},
		{
			path: '/dispatches/maintance',
			title: 'Maintenance',
			icon: 'DM',
			class: '',
			anchor: 'dispatch-maintance',
		},
		{
			path: '/dispatches/route-maintance',
			title: 'Route Maintenance',
			icon: 'DRM',
			class: '',
			anchor: 'dispatch-route-maintance',
		},
		{
			path: '/dispatches/dispatch-report',
			title: 'Dispatch report',
			icon: 'DR',
			class: '',
			anchor: 'dispatch-report',
		},
		]
	},
	{
		path: '/receivables',
		title: 'Receivables',
		icon: 'payments',
		class: '',
		anchor: 'receivables',
		children: [{
			path: '/receivables/dashboard',
			title: 'Receivables Dashboard',
			icon: 'RD',
			class: '',
			anchor: 'receivables-dashboard',
		},
		{
			path: '/receivables/payment-entry',
			title: 'Payment Entry',
			icon: 'PE',
			class: '',
			anchor: 'receivables-entry',
		},
		{
			path: '/receivables/vendor-intake',
			title: 'Vendor Intake',
			icon: 'VI',
			class: '',
			anchor: 'receivables-vendor-intake',
		},
		{
			path: '/receivables/payment-entry-shipvia',
			title: 'Payment Entry By Terms Code',
			icon: 'PE',
			class: '',
			anchor: 'receivables-entry-byshipvia',
		},

		{
			path: '/receivables/journal-report',
			title: 'Receiving Journal Reports',
			icon: 'RJ',
			class: '',
			anchor: 'journal-report',
		},
		{
			path: '/receivables/daily-transactions',
			title: 'Daily Transactions',
			icon: 'DT',
			class: '',
			anchor: 'daily-transactions',
		},
		{
			path: '/receivables/dri',
			title: 'Daily Receivables Inquiry',
			icon: 'DRI',
			class: '',
			anchor: 'dri',
		},
		{
			path: '/receivables/payment-report',
			title: 'Payment Report',
			icon: 'PR',
			class: '',
			anchor: 'receivables-payments',
		},
		{
			path: '/receivables/pos-sales-report',
			title: 'SalonCentric Sales Report',
			icon: 'SPSR',
			class: '',
			anchor: 'receivables-pos-sales',
		},
		{
			path: '/receivables/credit-note',
			title: 'Credit Entry',
			icon: 'CE',
			class: '',
			anchor: 'receivables-credit-note',
		},
		{
			path: '/receivables/allocations',
			title: 'Open Payments/Credits',
			icon: 'A',
			class: '',
			anchor: 'receivables-allocations',
		},
		{
			path: '/receivables/dayend-checkout',
			title: 'Day End Checkout',
			icon: 'C',
			class: '',
			anchor: 'dayend-checkout',
		},
		{
			path: '/receivables/rsi',
			title: 'Sales Inquiry',
			icon: 'RSI',
			class: '',
			anchor: 'rsi',
		},
		{
			path: '/receivables/dreg',
			title: 'Daily Register',
			icon: 'DREG',
			class: '',
			anchor: 'dreg',
		},
		{
			path: '/receivables/payment-terms-batch',
			title: 'Payment by Term - Batch Processing',
			icon: 'PB',
			class: '',
			anchor: 'payment-terms-batch',
		},
		{
			path: '/receivables/statements',
			title: 'Statements',
			icon: 'RS',
			class: '',
			anchor: 'receivables-statements',
		},
		{
			path: '/receivables/ar-interest-invoices',
			title: 'AR Interest Invoices',
			icon: 'ARI',
			class: '',
			anchor: 'ar-interest-invoices',
		},
		{
			path: '/receivables/collection-tracker',
			title: 'Collection Tracker',
			icon: 'CT',
			class: '',
			anchor: 'receivables-collection-tracker',
		},
		],
		reports: [{
			path: '/receivables/srpt',
			title: 'Salesman Sales by Branch',
			icon: 'SRPT',
			class: '',
		},
		{
			path: '/receivables/brand-report',
			title: 'Brand Sales Report',
			icon: 'BRPT',
			class: '',
		},

		]
	},
	{
		path: '/education',
		title: 'Education',
		icon: 'school',
		class: '',
		anchor: 'education',
		children: [{
			path: '/education/education-events',
			title: 'Education Events',
			icon: 'EE',
			class: '',
			anchor: 'education-events',
		},
		{
			path: '/education/education-locations',
			title: 'Education Locations',
			icon: 'EL',
			class: '',
			anchor: 'education-locations',
		},
		{
			path: '/education/attendees',
			title: 'Education Attendees',
			icon: 'EA',
			class: '',
			anchor: 'attendees',
		},
		{
			path: '/education/education-rewards',
			title: 'Loyalty Programs',
			icon: 'LP',
			class: '',
			anchor: 'education-rewards',
		}, ],
		reports: [{
			path: '/education/voucher-report',
			title: 'Voucher Usage',
			icon: 'EV',
			class: '',
		},{
			path: '/education/education-numbers',
			title: 'Education Numbers',
			icon: 'EN',
			class: '',
		},]
	},

	/*{ path: '/payables', title: 'Payables',icon:'account_balance', class: '' , anchor: 'payables', children: [
		{
		 path: '/purchasing/purchasing-dash',
		 title: 'Payables Dashboard',
		 icon: 'PD',
		 class: '',
		 anchor: 'payables-dash',
	 },
 	]},
	 */
	//package beauty is temporary. need to move it to multi warehouse config
	{
		path: '/inventory',
		title: 'Inventory',
		icon: 'category',
		class: '',
		anchor: 'inventory',
		children: [{
			path: '/inventory/dashboard',
			title: 'Inventory Dashboard',
			icon: 'ID',
			class: '',
		},
		{
			path: '/inventory/list',
			title: 'Item Maintenance',
			icon: 'IM',
			class: '',
		},

		{
			path: '/inventory/inventory-promos',
			title: 'Promos',
			icon: 'IP',
			class: '',
			package: 'beauty',
		},
		{
			path: '/inventory/inventory-transfers',
			title: 'Inventory Transfers',
			icon: 'IT',
			class: '',
			package: '',
		},
		{
			path: '/inventory/branch-reorder',
			title: 'Store Re-Ordering',
			icon: 'BR',
			class: '',
			package: '',
		},
		{
			path: '/inventory/weekly-reorder-inventory',
			title: 'Weekly Re-Ordering',
			icon: 'BR',
			class: '',
			package: '',
		},
		// Inventory and Reordering
		{
			path: '/inventory/classic-reorder',
			title: 'Classic Re-Ordering',
			icon: 'BR',
			class: '',
			package: ''
		},
		{
			path: '/inventory/special-pricing',
			title: 'Item Specials',
			icon: 'ISM',
			class: '',
		},
		{
			path: '/inventory/commissions',
			title: 'Item Commissions',
			icon: 'IC',
			class: '',
		},
		{
			path: '/inventory/value',
			title: 'Inventory Valuation',
			icon: 'IV',
			class: '',
		},

		{
			path: 'inventory/maintaince/price-level-pricing',
			title: 'Discount Pricing',
			icon: 'iu',
			class: '',
			anchor: 'inventory-price-level-pricing'
		},
		{
			path: 'inventory/item-inquiry',
			title: 'Item Inquiry',
			icon: 'IIQ',
			class: '',
			anchor: 'inventory-item-inquiry'
		},
		{
			path: '/inventory/inventory-upload',
			title: 'Inventory Upload',
			icon: 'iu',
			class: '',
			anchor: 'inventory-upload'
		},
		{
			path: '/inventory/xref-cost-upload',
			title: 'Xref cost upload',
			icon: 'iu',
			class: '',
			anchor: 'xref-cost-upload'
		},
		{
			path: '/inventory/batch-cost-update',
			title: 'Batch cost update',
			icon: 'bcu',
			class: '',
			anchor: 'batch-cost-update'
		},
		{
			path: '/inventory/single-item-transfer',
			title: 'Single Item Transfer',
			icon: 'SIT',
			class: '',
			anchor: 'single-item-transfer'
		},
		{
			path: '/inventory/fet-report',
			title: 'Fet Report',
			icon: 'FET',
			class: '',
			anchor: 'fet-report'
		},
		{
			path: '/inventory/sticker-feed',
			title: 'Sticker Feeds',
			icon: 'SFE',
			class: '',
			anchor: 'sticker-geed'
		},
		{
			path: '/inventory/maintaince',
			title: 'Inventory Maintance',
			icon: 'iu',
			class: '',
			anchor: 'inventory-maintance',
			children: [{
				path: '/inventory/maintaince/price-level-pricing',
				title: 'Price Level Pricing',
				icon: 'ID',
				class: '',
			}]
		},
		],
		reports: [{
			path: '/inventory/idet-report',
			title: 'Item Detail Report',
			icon: 'IGR',
			class: '',
			anchor: 'productline-report'
		},
		{
			path: '/inventory/top-hundred',
			title: 'Top 100 Items',
			icon: '100',
			class: '',
			anchor: 'top-hundred'
		},
		{
			path: '/inventory/customer-item-prodline-sales',
			title: 'Customer Item Sales by Product Line',
			icon: 'ITM',
			class: '',
			anchor: 'customer-item-prodline-sales'
		},
		{
			path: '/inventory/non-turning-inventory',
			title: 'Non-Turning Inventory',
			icon: 'NTI',
			class: '',
			anchor: 'non-turning-inventory'
		},

		]

	},
	{
		path: '/purchasing',
		title: 'Purchasing',
		icon: 'shopping_bag',
		class: '',
		anchor: 'purchases',
		children: [{
			path: '/purchasing/dashboard',
			title: 'Purchasing Dashboard',
			icon: 'PD',
			class: '',
			anchor: 'purchasing-dashboard'
		},
		{
			path: '/purchasing',
			title: 'New Purchase Order',
			icon: 'PE',
			class: '',
			anchor: 'purchasing-entry'
		},
		{
			path: '/purchasing/openorders',
			title: 'Open Purchase Orders',
			icon: 'PO',
			class: '',
			anchor: 'purchasing-open'
		},
		{
			path: '/purchasing/opengrns',
			title: 'Outstanding GRNs',
			icon: 'OG',
			class: '',
			anchor: 'purchasing-open-grns'
		},
		{
			path: '/purchasing-order-inquiry',
			title: 'Purchase Order Inquiry',
			icon: 'POI',
			class: '',
			anchor: 'purchasing-order-inquiry'
		},
		{
			path: '/purchasing/reorder',
			title: 'Re-Order',
			icon: 'RO',
			class: '',
			anchor: 'purchasing-reorder',
			/*children: [
						{
							path: '/purchasing/reorder/restock',
							 title: 'Re-Stock',
							 icon: 'RS',
							 class: '',
							 anchor: 'purchasing-restock'
						},
						{
							path: '/purchasing/reorder/minmax',
							 title: 'Min Max',
							 icon: 'MM',
							 class: '',
							 anchor: 'purchasing-minmax'
						},
						{
							path: '/purchasing/reorder/avgsales',
							 title: 'Sales Over Time',
							 icon: 'ST',
							 class: '',
							 anchor: 'purchasing-avgsales'
						}

					  ]*/
		},
		{
			path: '/purchasing/brand-priority',
			title: 'Brand Priority',
			icon: 'BP',
			class: '',
			anchor: 'purchasing-brands'
		},
		{
			path: '/purchasing/brand-priority/view',
			title: 'Brand Priority (View Only)',
			icon: 'BP',
			class: '',
			anchor: 'purchasing-brands-view'
		},
			/*{
					path: 'purchasing-receipt-upload',
					title: 'Purchasing Receipt Upload',
					icon: 'PLU',
					class: '',
					anchor: 'purchasing-upload'
				},
				*/
		]
	},
	// Fixed Assets
	{
		path: '/fixed-assets',
		title: 'Fixed Assets',
		icon: 'view_list',
		class: '',
		anchor: 'system-fixed-assets',
		children: [
			{
				path: '/fixed-assets/fixed-assets-management',
				title: 'Fixed Asset Management',
				icon: 'FI',
				class: ''
			}]
	},
	{
		path: '/general-ledger',
		title: 'General Ledger',
		icon: 'category',
		class: '',
		anchor: 'generallendger',
		children: [
			{
				path: '/general-ledger/journal-entry',
				title: 'Journal Entry',
				icon: 'JE',
				class: '',
			},
			{
				path: '/general-ledger/journal-inquiry',
				title: 'Journal Inquiry',
				icon: 'JI',
				class: '',
			},
			{
				path: '/general-ledger/gl-impact',
				title: 'GL impact',
				icon: 'GI',
				class: '',
			},
			{
				path: '/general-ledger/account-inquiry',
				title: 'Account Inquiry',
				icon: 'AI',
				class: '',
			},
			{
				path: '/general-ledger/document-lookup',
				title: 'Find Document',
				icon: 'FD',
				class: '',
			},
			{
				path: '/general-ledger/trial-balance',
				title: 'Trial Balance',
				icon: 'TB',
				class: '',
			},
			{
				path: '/general-ledger/simple-trial-balance',
				title: 'Simple Trial Balance',
				icon: 'STB',
				class: '',
			},
			{
				path: '/general-ledger/sales-ledger-control',
				title: 'Unbalanced Transactions',
				icon: 'SLC',
				class: '',
			},
			{
				path: '/general-ledger/profit-and-loss',
				title: 'Profit And Loss',
				icon: 'P&L',
				class: '',
			},
			{
				path: '/general-ledger/balance-sheet',
				title: 'Balance Sheet',
				icon: 'BAL',
				class: '',
			},
			{
				path: '/general-ledger/bank-rec',
				title: 'Bank Rec',
				icon: 'BR',
				class: '',
			},
			{
				path: '/general-ledger/sales-taxes',
				title: 'Sales Taxes',
				icon: 'ST',
				class: '',
			},
			{
				path: '/general-ledger/tax-authority-report',
				title: 'Tax reporting (AR/AP)',
				icon: 'TR',
				class: '',
			},
			{
				path: '/general-ledger/third-party-sales-gl',
				title: '3rd Party Sales GL',
				icon: '3GL',
				class: '',
			},
			{
				path: '/general-ledger/shield-compliance',
				title: 'Shield Compliance',
				icon: 'SC',
				class: '',
			},
			{
				path: '/general-ledger',
				title: 'Maintenance',
				icon: 'm',
				class: '',
				anchor: 'general-ledger-maintenance',
				children: [{
					path: '/system/gl-accounts/account-sections',
					title: 'Account Sections',
					icon: 'AS',
					class: '',
				},
				{
					path: '/system/gl-accounts/account-groups',
					title: 'Account Groups',
					icon: 'AG',
					class: '',
				},
				{
					path: '/system/gl-accounts',
					title: 'Chart of Accounts',
					icon: 'COA',
					class: '',
				},
				{
					path: '/system/bank-accounts',
					title: 'Bank Accounts',
					icon: 'BA',
					class: '',
				},
				{
					path: '/general-ledger/budgets',
					title: 'GL Budgets',
					icon: 'BDT',
					class: '',
				},
				{
					path: '/general-ledger/tags',
					title: 'GL Tags',
					icon: 'GT',
					class: '',
				},
				{
					path: '/general-ledger/general-posting-setup',
					title: 'General Posting Setup',
					icon: 'GPS',
					class: '',
				},
				{
					path: '/general-ledger/sales-gl-postings',
					title: 'Sales GL',
					icon: 'SGL',
					class: '',
				},
				{
					path: '/general-ledger/cogs-gl-postings',
					title: 'Cogs GL',
					icon: 'CGl',
					class: '',
				},
				{
					path: '/general-ledger/inventory-gl-postings',
					title: 'Inv GL',
					icon: 'IGL',
					class: '',
				},
				{
					path: '/general-ledger/gl-close-control',
					title: 'Close / ReOpen GL',
					icon: 'CGL',
					class: '',
				},
				{
					path: '/general-ledger/department-required',
					title: 'Dept Required Accounts',
					icon: 'DRA',
					class: '',
				},
				]
			},
		],
	},
	{
		path: '/reports',
		title: 'Reports',
		icon: 'bubble_chart',
		class: '',
		anchor: 'reports',
		package: 'all',
		children: [
			{
				path: '/reports',
				title: 'Report catalog',
				icon: 'RC',
				class: '',
				anchor: 'reports-catalog',
			},
			{
				path: '/reports/customer-credit-cards',
				title: 'Customers with Credit Cards',
				icon: 'CCC',
				class: '',
				anchor: 'reports-customer-credit-cards',
			},
			{
				path: '/reports/new-items',
				title: 'New Items Report',
				icon: 'NITMS',
				class: '',
				anchor: 'reports-new-items',
			},
			{
				path: '/reports/brand-sales-ranking',
				title: 'Brand Sales by Salesperson',
				icon: 'BSR',
				class: '',
				anchor: 'reports-brand-sales-ranking',
			},
		],
	},
	{
		path: '/users',
		title: 'Users',
		icon: 'admin_panel_settings',
		class: '',
		anchor: 'users',
		children: [{
			path: '/users-list',
			title: 'Users',
			icon: 'UL',
			anchor: 'user-list',
			class: '',
		},
		{
			path: '/usergroups',
			title: 'User Groups',
			icon: 'UG',
			anchor: 'user-groups',
			class: '',
		},
		{
			path: '/users/salesperson-app-users',
			title: 'Salesperson app users',
			icon: 'SA',
			anchor: 'salesperson-app-users',
			class: '',
		},
		{
			path: '/users/vendors',
			title: 'Vendors',
			icon: 'VN',
			anchor: 'vendors',
			class: '',
		}]
	},
	{ path: '/archive', title: 'Archive', icon: 'bubble_chart', class: '', anchor: 'archive-list', package: 'all' },
	{
		path: '/tpl3pl',
		title: '3PL',
		icon: 'local_shipping',
		class: '',
		anchor: 'tpl3pl',
		children: [
			{ path: '/tpl3pl/dashboard', title: 'Dashboard', icon: 'DB', class: '' },
			{ path: '/tpl3pl/config', title: 'Configuration', icon: 'CF', class: '' },
			{ path: '/tpl3pl/export-queue', title: 'Order Export', icon: 'OE', class: '' },
			{ path: '/tpl3pl/inbound', title: 'Inbound', icon: 'IB', class: '' },
			{ path: '/tpl3pl/open-orders', title: 'Open Orders', icon: 'OO', class: '' },
			{ path: '/tpl3pl/shipments', title: 'Shipments', icon: 'SH', class: '' },
			{ path: '/tpl3pl/capture-auths', title: 'Capture Auths', icon: 'CA', class: '' },
			{ path: '/tpl3pl/void-auths', title: 'Void Auths', icon: 'VA', class: '' },
			{ path: '/tpl3pl/inventory', title: 'Inventory', icon: 'IN', class: '' },
			{ path: '/tpl3pl/manual-sku-push', title: 'Manual SKU push', icon: 'MS', class: '' },
			{ path: '/tpl3pl/logs', title: 'Logs', icon: 'LG', class: '' }
		]
	},
	{
		path: '/storefront',
		title: 'Storefront',
		icon: 'storefront',
		class: '',
		anchor: 'storefront',
		package: 'beauty',
		storefrontStandaloneOnly: true,
		children: [
			{ path: '/storefront/banners', title: 'Banners', icon: 'BN', class: '', anchor: 'storefront-banners' },
			{ path: '/storefront/categories', title: 'Categories', icon: 'CT', class: '', anchor: 'storefront-categories' },
			{ path: '/storefront/customer-approval', title: 'Customer Approval', icon: 'CA', class: '', anchor: 'storefront-customer-approval' },
			{ path: '/storefront/information', title: 'Information', icon: 'IF', class: '', anchor: 'storefront-information' },
			{ path: '/storefront/qr-codes', title: 'QR Codes', icon: 'QR', class: '', anchor: 'storefront-qr-codes' },
			{ path: '/storefront/bestsellers', title: 'Best Sellers', icon: 'BL', class: '', anchor: 'storefront-bestsellers' }
		]
	},
	{
		path: '/system',
		title: 'System',
		icon: 'dns',
		class: '',
		anchor: 'system',
		children: [
			// Core Setup
			{
				path: '/system/company',
				title: 'Company Setup',
				icon: 'CS',
				class: '',
				anchor: 'company-settings'
			},
			{
				path: '/system/types',
				title: 'Types Setup',
				icon: 'SS',
				class: '',
				anchor: 'company-types'
			},
			{
				path: '/system/status-maintenance',
				title: 'Status maintenance',
				icon: 'SS',
				class: '',
				anchor: 'status-maintenance'
			},
			{
				path: '/system/taxes',
				title: 'Tax Settings',
				icon: 'T',
				class: '',
				anchor: 'taxes'
			},
			{
				path: '/system/currencies',
				title: 'Currencies',
				icon: 'C',
				class: '',
				anchor: 'currencies'
			},
			{
				path: '/system/inventory-settings',
				title: 'Inventory Settings',
				icon: 'IS',
				class: '',
				anchor: 'system-inventory-lines'
			},

			// Customer & Product Management
			{
				path: '/system/customer-groups',
				title: 'Customer Groups',
				icon: 'CG',
				class: '',
				anchor: 'customer-groups',
				package: 'beauty'
			},
			{
				path: '/system/product-groups',
				title: 'Product Groups',
				icon: 'PG',
				class: '',
				anchor: 'product-groups',
				package: 'beauty'
			},

			// Sales & Marketing
			{
				path: '/system/coupons',
				title: 'Coupons',
				icon: 'C',
				class: '',
				anchor: 'coupons',
				package: 'beauty'
			},
			{
				path: '/system/marketing',
				title: 'Marketing',
				icon: 'M',
				class: '',
				anchor: 'marketing',
				package: 'beauty',
			},
			{
				path: '/system/sale-builder',
				title: 'Sale Builder',
				icon: 'SB',
				class: '',
				anchor: 'sale-builder'
			},
			{
				path: '/system/storefront-settings',
				title: 'Storefront settings',
				icon: 'SS',
				class: '',
				anchor: 'storefront-settings',
				package: 'beauty',
				hideWhenStorefrontStandalone: true
			},
			// {
			// 	path: '/design-control',
			// 	title: 'Design Control',
			// 	icon: 'DC',
			// 	class: '',
			// 	anchor: 'design-control'
			// },
			{
				path: '/system/system-notice',
				title: 'System Notice',
				icon: 'SN',
				class: '',
				anchor: 'system-notice'
			},
			{
				path: '/system/scheduler',
				title: 'Scheduled Jobs',
				icon: 'SC',
				class: '',
				anchor: 'scheduler'
			},

			// Shipping & Tools
			{
				path: '/system/shipvia',
				title: 'Shipping Setup',
				icon: 'SS',
				class: '',
				anchor: 'system-shipvia'
			},
			{
				path: '/system/sales-areas',
				title: 'Sales Areas & Territories',
				icon: 'SA',
				class: '',
				anchor: 'system-sales-areas'
			},
			{
				path: '/system/tools',
				title: 'Tools',
				icon: 'T',
				class: '',
				anchor: 'tools',
				package: false,
				children: [
					{
						path: '/system/merge-customers',
						title: 'Merge Customers',
						icon: 'MC',
						class: '',
						anchor: 'merge-customers',
						package: false
					},
					{
						path: '/system/matrix-copy',
						title: 'Copy Customer Matrix',
						icon: 'CCM',
						class: '',
						anchor: 'matrix-copy',
						package: false
					},
					{
						path: '/system/matrix-brands',
						title: 'Customer Brand Matrix',
						icon: 'CBM',
						class: '',
						anchor: 'matrix-brands',
						package: false
					},
					{
						path: '/system/brand-storefronts',
						title: 'Brand Storefronts',
						icon: 'BSF',
						class: '',
						anchor: 'brand-storefronts',
						package: false
					},
					{
						path: '/system/move-transactions',
						title: 'Move Transactions',
						icon: 'MT',
						class: '',
						anchor: 'move-transactions',
						package: false
					},
					{
						path: '/system/move-vendor-transactions',
						title: 'Move Vendor Transactions',
						icon: 'MV',
						class: '',
						anchor: 'move-vendor-transactions',
						package: false
					},
					{
						path: '/system/form-builder',
						title: 'Form Builder',
						icon: 'FB',
						class: '',
						anchor: 'form-builder',
						package: false
					}]
			},

			// Reporting & APIs
			{
				path: '/system/report-builder',
				title: 'Report Builder',
				icon: 'RB',
				class: '',
				anchor: 'report-builder'
			},
			{
				path: '/system/api-settings',
				title: 'Remote API Settings',
				icon: 'RA',
				class: '',
				anchor: 'remote-api-settings'
			},
		],
	},
	{
		path: '/metrc',
		title: 'Metrc',
		icon: 'verified',
		class: '',
		anchor: 'metrc',
		children: [
			{ path: '/metrc/dashboard', title: 'Metrc Dashboard', icon: 'MD', class: '', anchor: 'metrc-dashboard' },
			{ path: '/metrc/packages', title: 'Packages', icon: 'PK', class: '', anchor: 'metrc-packages' },
			{ path: '/metrc/transfers', title: 'Transfers', icon: 'TR', class: '', anchor: 'metrc-transfers' },
			{ path: '/metrc/mappings', title: 'Stock Mappings', icon: 'SM', class: '', anchor: 'metrc-mappings' },
			{ path: '/metrc/orders', title: 'Order Sync', icon: 'OS', class: '', anchor: 'metrc-orders' },
			{ path: '/metrc/picking', title: 'Picking', icon: 'PI', class: '', anchor: 'metrc-picking' },
			{ path: '/metrc/receiving', title: 'Receiving', icon: 'RC', class: '', anchor: 'metrc-receiving' },
			{ path: '/metrc/presplit', title: 'Inventory', icon: 'IN', class: '', anchor: 'metrc-inventory' },
			{ path: '/metrc/receipts', title: 'POS Receipts', icon: 'PR', class: '', anchor: 'metrc-receipts' },
			{ path: '/metrc/order-import', title: 'Order Import', icon: 'OI', class: '', anchor: 'metrc-order-import' },
			{ path: '/metrc/queue', title: 'Job Queue', icon: 'JQ', class: '', anchor: 'metrc-queue' },
			{ path: '/metrc/reference', title: 'Reference Data', icon: 'RD', class: '', anchor: 'metrc-reference' },
			{ path: '/metrc/config', title: 'Configuration', icon: 'CF', class: '', anchor: 'metrc-config' }
		]
	},
	{ path: '/logout', title: 'Logout', icon: 'logout', class: '', package: 'all' },
];

/** Matches /reports/view/{type}/{file...} including nested paths (e.g. receivables/drilldown/x.sql). */
export function reportViewUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
	if (segments.length < 4) {
		return null;
	}
	if (segments[0].path !== 'reports' || segments[1].path !== 'view') {
		return null;
	}
	const type = segments[2].path;
	const id = segments
		.slice(3)
		.map(s => s.path)
		.join('/');
	return {
		consumed: segments,
		posParams: {
			type: new UrlSegment(type, {}),
			id: new UrlSegment(id, {}),
		},
	};
}

//ACTUAL ROUTES
export const AdminLayoutRoutes: Routes = [
	{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
	{ path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
	{ path: 'reports/customer-credit-cards', component: CustomerCreditCardsReportComponent, canActivate: [AuthGuard] },
	{ path: 'reports/new-items', component: NewItemsReportComponent, canActivate: [AuthGuard] },
	{ matcher: reportViewUrlMatcher, component: ReportViewComponent, canActivate: [AuthGuard] },

	{ path: 'counter-pos', component: CounterPosComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos-dashboard', component: CounterPosDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/openorders', component: OrderOpenlistComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/dri', component: DriComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/iq', component: ItemQueryComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/stock-counts', component: WarehouseStockCountsComponent, canActivate: [AuthGuard] },

	{ path: 'counter-pos/dreg', component: DregComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/daily-transactions', component: DailyTransactionsComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/cid-report', component: CidReportComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos-invoice/:id/:dispatch', component: CounterPosInvoiceComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/:cid/:branch/:empcode', component: CounterPosComponent, canActivate: [AuthGuard] },
	{ path: 'counter-pos/:cid/:branch', component: CounterPosComponent, canActivate: [AuthGuard] },

	{ path: 'counter-pos/payment-report', component: PaymentReportComponent, canActivate: [AuthGuard] },
	{ path: 'pos/success/:id', component: PosReceiptComponent, canActivate: [AuthGuard] },
	//hold over
	{ path: 'credits/success/:id', component: SuccessComponent, canActivate: [AuthGuard] },

	{ path: 'orders', component: OrdersDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'orders/dynamic', component: UserDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'orders/adrs', component: AdrsComponent, canActivate: [AuthGuard] },
	{ path: 'orders/entry', component: CustomerSearchComponent, canActivate: [AuthGuard] },
	{ path: 'orders/entry/new', component: CustomerSearchComponent, canActivate: [AuthGuard] },
	{ path: 'orders/entry/:cid/:branch', component: OrderEntryComponent, canActivate: [AuthGuard] },
	{ path: 'orders/load/:cid/:branch/:orderno', component: OrderLoadComponent, canActivate: [AuthGuard] },
	//{ path: 'orders/invoice/:id', component: OrderInvoiceComponent, canActivate: [AuthGuard] },
	{ path: 'orders/invoice/:id/:dispatch', component: OrderDispatchComponent, canActivate: [AuthGuard] },
	{ path: 'orders/email-intake', component: EmailIntakeComponent, canActivate: [AuthGuard] },
	{ path: 'archive', component: ArchiveListComponent, canActivate: [AuthGuard] },

	{ path: 'orders/order-inquiry', component: OrderInquiryComponent, canActivate: [AuthGuard] },
	{ path: 'orders/batch-invoice-print', component: BatchInvoicePrintComponent, canActivate: [AuthGuard] },
	{ path: 'orders/order-item-inquiry', component: OrderItemInquiryComponent, canActivate: [AuthGuard] },
	{ path: 'orders/channel-reports', component: ChannelreportsComponent, canActivate: [AuthGuard] },
	{ path: 'orders/promo-intro', component: PromoIntroComponent, canActivate: [AuthGuard] },
	{ path: 'reports/brand-sales-ranking', component: BrandSalesRankingComponent, canActivate: [AuthGuard] },
	{ path: 'orders/channel-orders', component: ChannelordersComponent, canActivate: [AuthGuard] },
	{ path: 'orders/order-tracking', component: OrderTrackingComponent, canActivate: [AuthGuard] },
	{ path: 'orders/simpletire-orders', component: SimpletireOrderProcessingComponent, canActivate: [AuthGuard] },
	{ path: 'orders/order-entry-log', component: OrderEntryLogComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/single-item-transfer', component: SingleItemTransferComponent, canActivate: [AuthGuard] },
	{ path: 'orders/productline-report', component: ProductlineReportComponent, canActivate: [AuthGuard] },

	{ path: 'orders/qantel-dashboard', component: QantelOrderDashComponent, canActivate: [AuthGuard] },
	{ path: 'orders/qantel-dashboard/:type', component: QantelOrderDashComponent, canActivate: [AuthGuard] },

	{ path: 'orders/dashboard', component: OrdersDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'orders/dashboard/:type', component: OrdersDashboardComponent, canActivate: [AuthGuard] },

	{ path: 'orders/order-confirmation', component: OrderConfirmationComponent, canActivate: [AuthGuard] },
	{ path: 'orders/order-confirmation/:id', component: OrderConfirmationComponent, canActivate: [AuthGuard] },

	{ path: 'orders/lookup', component: OrderLookupComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/visits', component: WarehouseVisitsComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/pick-board', component: PickBoardComponent, canActivate: [AuthGuard] },
	// One component, two stages: `data.stage` is what tells it whether it is
	// counting pick→picked or picked→loaded.
	{ path: 'warehouse/pick-station', component: PickStationComponent, canActivate: [AuthGuard], data: { stage: 'pick' } },
	{ path: 'warehouse/pick-station/:orderno', component: PickStationComponent, canActivate: [AuthGuard], data: { stage: 'pick' } },
	{ path: 'warehouse/check-station', component: PickStationComponent, canActivate: [AuthGuard], data: { stage: 'check' } },
	{ path: 'warehouse/check-station/:orderno', component: PickStationComponent, canActivate: [AuthGuard], data: { stage: 'check' } },
	{ path: 'orders/pick', component: OrderPickComponent, canActivate: [AuthGuard] },
	{ path: 'orders/pick/:id', component: OrderPickComponent, canActivate: [AuthGuard] },

	{ path: 'orders/check', component: OrderCheckComponent, canActivate: [AuthGuard] },
	{ path: 'orders/check/:id', component: OrderCheckComponent, canActivate: [AuthGuard] },



	{ path: 'orders/lookup/:id', component: OrderLookupComponent, canActivate: [AuthGuard] },
	{ path: 'orders/lookup/:id/:type', component: OrderLookupComponent, canActivate: [AuthGuard] },
	{ path: 'orders/openorders', component: OrderOpenlistComponent, canActivate: [AuthGuard] },
	{ path: 'orders/openquotes', component: OrdersOpenQuotesComponent, canActivate: [AuthGuard] },
	{ path: 'orders/canceledorders', component: CanceledOrdersComponent, canActivate: [AuthGuard] },
	{ path: 'orders/spiffreport', component: SpiffReportComponent, canActivate: [AuthGuard] },
	{ path: 'orders/success/:id', component: OrderSuccessComponent, canActivate: [AuthGuard] },
	{ path: 'orders/reprintpick', component: OrderReprintPickComponent, canActivate: [AuthGuard] },
	{ path: 'orders/oms', component: OdsComponent, canActivate: [AuthGuard] },
	{ path: 'orders/time', component: TimelineComponent, canActivate: [AuthGuard] },
	{ path: 'orders/jpms', component: JpmsReportComponent, canActivate: [AuthGuard] },
	{ path: 'orders/spiff', component: SpiffReportComponent, canActivate: [AuthGuard] },
	{ path: 'orders/pmm', component: ReportsPmmComponent, canActivate: [AuthGuard] },
	// { path: 'orders/pick',	 component: PickComponent },
	{ path: 'dispatches', component: DispatchesComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/dashboard', component: DispatchesDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/route', component: RouteBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/active', component: DispatchesActiveDispatchComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/route-builder', component: DispatchesRouteBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/baypriority', component: DispatchesLoadPriorityComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/drivers', component: DispatchesDriverRunComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/drivers/:id', component: DispatchesDriverRunComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/deliverednotinvoiced', component: DispatchesDeliveredNotinvoicedComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/maintance', component: DispatchesMaintanceComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/route-maintance', component: DispatchesRouteMaintanceComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/dispatch-report', component: DispatchesDispatchReportComponent, canActivate: [AuthGuard] },

	{ path: 'dispatches/load-sheet', component: DispatchesLoadSheetComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/load-sheet/:id', component: DispatchesLoadSheetComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/driver-unload', component: DispatchDriverUnloadComponent, canActivate: [AuthGuard] },



	{ path: 'inventory/dashboard', component: InventoryDashboardComponent, canActivate: [AuthGuard] },


	//{ path: 'inventory/:id',	 component: InventoryComponent },

	{ path: 'inventory/lookup', component: InventoryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/lookup/:id', component: InventoryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/view/:id', component: InventoryViewComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/list', component: InventoryListComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/value', component: InventoryValueComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/inventory-transfers', component: InventoryTransfersComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/inventory-promos', component: InventoryPromosComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/branch-reorder', component: BranchReorderComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/weekly-reorder', component: WeeklyReorderComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/classic-reorder', component: ClassicReorderComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/weekly-reorder-inventory', component: WeeklyReorderComponent, canActivate: [AuthGuard] },

	{ path: 'inventory/idet-report', component: IdetReportComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/customer-item-prodline-sales', component: CustomerItemProdlineSalesComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/top-hundred', component: TopHundredComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/non-turning-inventory', component: NonTurningInventoryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/maintaince/price-level-pricing', component: PriceLevelPricingComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/item-inquiry', component: ItemQueryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/fet-report', component: StickerPaymentProcessingComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/sticker-feed', component: StickerFeedControlComponent, canActivate: [AuthGuard] },
	{ path: 'customers', component: CustomersComponent, canActivate: [AuthGuard] },
	{ path: 'customer/groups', component: CustomersGroupsComponent, canActivate: [AuthGuard] },

	{ path: 'customers/dahbaord', component: CustomerDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'customers/view/:id', component: ViewComponent, canActivate: [AuthGuard] },
	{ path: 'customers/edit/:id', component: CustomerEditComponent, canActivate: [AuthGuard] },
	{ path: 'customers/customer-export', component: CustomerExportComponent, canActivate: [AuthGuard] },
	{ path: 'customers/customer-payments', component: CustomerPaymentsReportComponent, canActivate: [AuthGuard] },
	{ path: 'customers/rep-bulk-enable', component: RepBulkEnableComponent, canActivate: [AuthGuard] },
	{ path: 'customers/create', component: CustomerCreateComponent, canActivate: [AuthGuard] },
	{ path: 'customers/crpt', component: CrptComponent, canActivate: [AuthGuard] },
	{ path: 'customers/commission-sales', component: CommissionSalesReportComponent, canActivate: [AuthGuard] },
	{ path: 'customers/salesman-territory', component: SalesmanTerritoryReportComponent, canActivate: [AuthGuard] },
	{ path: 'customers/sales-route-builder', component: SalesRouteBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'customers/sales-route-runner', component: SalesRouteRunnerComponent, canActivate: [AuthGuard] },
	{ path: 'customers/cvsls', component: CvslsComponent, canActivate: [AuthGuard] },
	{ path: 'customers/csrpt', component: CsrptComponent, canActivate: [AuthGuard] },
	{ path: 'customers/itemHistory', component: CustomerItemHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'customers/itemHistory/:id', component: CustomerItemHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'customers/monthlyHistory', component: CustomerMonthlyHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'customers/monthlyHistory/:id', component: CustomerMonthlyHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'customers/reward-points', component: RewardPointsComponent, canActivate: [AuthGuard] },
	{ path: 'customers/cpsls', component: CpslsComponent, canActivate: [AuthGuard] },
	{ path: 'customers/cpsls/:id', component: CpslsComponent, canActivate: [AuthGuard] },
	{ path: 'customers/customer-cpdet', component: CustomerCpdetComponent, canActivate: [AuthGuard] },
	{ path: 'customers/customer-cpdet/:id', component: CustomerCpdetComponent, canActivate: [AuthGuard] },
	{ path: 'customers/cdet', component: CustomerCdetComponent, canActivate: [AuthGuard] },
	{ path: 'customers/cdet/:id', component: CustomerCdetComponent, canActivate: [AuthGuard] },
	// SALES MANAGER HACK
	{ path: 'sales-manager-reports', redirectTo: 'sales-manager-reports/dailytrans', pathMatch: 'full' },
	{ path: 'sales-manager-reports/spsls', component: SpslsComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/vrpt', component: VrptComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/crpt', component: CrptComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/commission-sales', component: CommissionSalesReportComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/salesman-territory', component: SalesmanTerritoryReportComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/sales-route-builder', component: SalesRouteBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cvsls', component: CvslsComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/csrpt', component: CsrptComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/itemHistory', component: CustomerItemHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/itemHistory/:id', component: CustomerItemHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/monthlyHistory', component: CustomerMonthlyHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/monthlyHistory/:id', component: CustomerMonthlyHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cpsls', component: CpslsComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cpsls/:id', component: CpslsComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/customer-cpdet', component: CustomerCpdetComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/customer-cpdet/:id', component: CustomerCpdetComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cdet', component: CustomerCdetComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cdet/:id', component: CustomerCdetComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/productline-report', component: ProductlineReportComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/dailytrans', component: DailyTransactionsComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/top-hundred', component: TopHundredComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/cid-report', component: CidReportComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/idet-report', component: IdetReportComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/sales-dashboard', component: SalesDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'sales-manager-reports/recurring-replenishment', component: RecurringReplenishmentComponent, canActivate: [AuthGuard] },



	{ path: 'customers/invoices/:id', component: CustomerOrdersComponent },
	{ path: 'customers/customer-vehicles/:cid', component: CustomerVehiclesComponent },
	{ path: 'customers/customer-vehicles/:cid/:id', component: CustomerVehiclesComponent },
	{ path: 'customers/consignment-edit/:id', component: ConsignmentEditComponent },

	{ path: 'vendors', component: VendorsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/create', component: VendorCreateComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/daily-transactions', component: VendorDailyTransactionsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/payment-report', component: VendorPaymentReportComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/payment-remittance', component: VendorPaymentRemittanceComponent, canActivate: [AuthGuard] },
	// Like vendor-intake below, MUST precede 'vendors/:id' or the catch-all matches
	// "open-payables" and loads VendorViewComponent for a vendor of that name.
	{ path: 'vendors/open-payables', component: OpenPayablesComponent, canActivate: [AuthGuard] },
	// Same intake screen surfaced under the Vendors menu. MUST precede 'vendors/:id' — otherwise the
	// :id catch-all matches "vendor-intake" and loads VendorViewComponent instead of the intake screen.
	{ path: 'vendors/vendor-intake', component: CreditMemoIntakeComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/:id', component: VendorViewComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/edit/:id', component: VendorEditComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/items/:id', component: VendorItemsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors-check-print', component: CheckPrintingComponent, canActivate: [AuthGuard] },
	{ path: 'vendors-check-print/:journal', component: CheckPrintingComponent, canActivate: [AuthGuard] },
	{ path: 'vendors-pending-payment-runs', component: PendingPaymentRunsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors-payment-run-review/:journal', component: PaymentRunReviewComponent, canActivate: [AuthGuard] },
	{ path: 'paymentrun', component: PaymentRunReportComponent, canActivate: [AuthGuard] },

	{ path: 'inventory/lookup', component: InventoryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/lookup/:id', component: InventoryComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/view/:id', component: InventoryViewComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/list', component: InventoryListComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/create', component: InventoryCreateComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/create/:id', component: InventoryCreateComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/special-pricing', component: SpecialPricingComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/commissions', component: CommissionsComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/inventory-upload', component: InventoryUploadComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/xref-cost-upload', component: XrefCostUploadComponent, canActivate: [AuthGuard] },
	{ path: 'inventory/batch-cost-update', component: BatchCostUpdateComponent, canActivate: [AuthGuard] },

	{ path: 'warehouse/bins', component: WarehouseBinsComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/finalize-rec', component: WarehouseFinalizerecComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/item-lookup', component: WarehouseItemLookupComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/dashboard', component: WarehouseDashboardComponent, canActivate: [AuthGuard] },
	//{ path: 'warehouse/item-scan', component: QantelItemSearchComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/item-scan', component: WarehouseItemScanComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/item-scan/:item', component: WarehouseItemScanComponent, canActivate: [AuthGuard] },

	{ path: 'warehouse/item-scan-two', component: WarehouseItemScanTwoComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/item-scan-two/:item', component: WarehouseItemScanTwoComponent, canActivate: [AuthGuard] },

	{ path: 'warehouse/item-scan-lite', component: WarehouseItemScanLiteComponent, canActivate: [AuthGuard] },

	{ path: 'warehouse/delivery-board', component: DeliveryBoardComponent, canActivate: [AuthGuard] },

	{ path: 'warehouse/receive', component: WarehouseItemReceivingComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/receive/:id', component: WarehouseItemReceivingComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/stock-counts', component: WarehouseStockCountsComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/stock-counts-scan', component: WarehouseStockcountsScanComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/warehouse-reports', component: WarehouseReportsComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/warehouse-loading', component: WarehouseCheckingComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/warehouse-loading-wifi', component: WarehouseCheckingWifiComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/warehouse-loading-fedex', component: WarehouseCheckingFedexComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/sticker-scan-out', component: StickerScanOutComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/sticker-scan-out-history', component: StickerScanOutHistoryComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/barcode-assigner', component: BarcodeAssignerComponent, canActivate: [AuthGuard] },
	{ path: 'warehouse/barcode-generator', component: BarcodeGeneratorComponent, canActivate: [AuthGuard] },
	//{ path: 'credit/picking', component: CreditReceiveComponent, canActivate: [AuthGuard] },

	{ path: 'customers', component: CustomersComponent, canActivate: [AuthGuard] },
	{ path: 'customers/dashboard', component: CustomerDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'customers/view/:id', component: ViewComponent, canActivate: [AuthGuard] },
	{ path: 'customers/edit/:id', component: CustomerEditComponent, canActivate: [AuthGuard] },
	{ path: 'customers/create', component: CustomerCreateComponent, canActivate: [AuthGuard] },

	{ path: 'customers/invoices/:id', component: CustomerOrdersComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/create', component: VendorCreateComponent, canActivate: [AuthGuard] },
	{ path: 'vendors-dashboard', component: VendorsDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'vendors', component: VendorsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/reports/vrpt', component: VrptComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/daily-transactions', component: VendorDailyTransactionsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/payment-remittance', component: VendorPaymentRemittanceComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/:id', component: VendorViewComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/edit/:id', component: VendorEditComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/items/:id', component: VendorItemsComponent, canActivate: [AuthGuard] },
	{ path: 'vendor-allocations', component: VendorAllocationsComponent, canActivate: [AuthGuard] },
	{ path: 'vendor-allocations/:transid', component: VendorAllocationsComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/:id/invoice', component: VendorInvoiceComponent, canActivate: [AuthGuard] },
	{ path: 'vendors/invoice/complete/:id', component: VendorInvoiceCompleteComponent, canActivate: [AuthGuard] },
	{ path: 'vehicles', component: VehiclesMainComponent, canActivate:[AuthGuard] },



	//purchasing
	{ path: 'purchasing', component: PurchaseCreateComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/dashboard', component: PurchasingDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/openorders', component: PurchasingOpenOrdersComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/opengrns', component: PurchasingOpenGrnsComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/receive', component: PurchaseOrderReceiveComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/receive/:id', component: PurchaseOrderReceiveComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/rga-return/:id', component: RgaReturnComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/brand-priority/view', component: PurchasingBrandPriorityComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/brand-priority', component: PurchasingBrandPriorityComponent, canActivate: [AuthGuard] },

	{ path: 'purchasing/reorder', component: PurchasingReorderingComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/reorder/restock', component: PurchasingReorderingRestockComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/reorder/minmax', component: PurchasingReorderingMinmaxComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/reorder/avgsales', component: PurchasingReorderingAvgsalesComponent, canActivate: [AuthGuard] },


	{ path: 'purchasing/:id', component: PurchaseCreateComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/:id/:order', component: PurchaseOrderEntryComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing-success/:id/:order', component: PurchasingSuccessComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing-receipt', component: PurchasingReceiptjournalComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing/order/view/:id', component: PurchaseOrderViewComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing-receipt-upload', component: PurchasingReceiptjournaluploadComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing-receipt-upload/:id', component: PurchasingReceiptjournaluploadComponent, canActivate: [AuthGuard] },
	{ path: 'purchasing-order-inquiry', component: PurchaseOrderInquiryComponent, canActivate: [AuthGuard] },

	//AR
	{ path: 'receivables/payment-entry', component: PaymentEntryComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/vendor-intake', component: CreditMemoIntakeComponent, canActivate: [AuthGuard] },
	// Back-compat alias for the former Credit-Memo Intake path (bookmarks, saved menus).
	{ path: 'receivables/credit-memo-intake', component: CreditMemoIntakeComponent, canActivate: [AuthGuard] },

	{ path: 'receivables/payment-entry-shipvia', component: ReceivablesByshipviaComponent, canActivate: [AuthGuard] },



	{ path: 'receivables/payment-entry/:id/:branch', component: PaymentEntryComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/journal-report', component: JournalReportComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/daily-transactions', component: DailyTransactionsComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/dri', component: DriComponent, canActivate: [AuthGuard] },

	{ path: 'receivables/payment-report', component: PaymentReportComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/pos-sales-report', component: PosSalesReportComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/payment-terms-batch', component: BatchDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/allocations', component: ReceivablesAllocationsComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/allocations/:transid', component: ReceivablesAllocationsComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/dayend-checkout', component: DayendCheckoutComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/rsi', component: RsiComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/dreg', component: DregComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/statements', component: StatementsComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/srpt', component: SrptComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/brand-report', component: BrandReportComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/ar-interest-invoices', component: ArInterestInvoicesComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/collection-tracker', component: CollectionTrackerComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/vendor-backed-remittance', component: VendorBackedRemittanceComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/vendor-backed-balances', component: VendorBackedBalancesComponent, canActivate: [AuthGuard] },
	{ path: 'reports/vendor-backed-payments', component: VendorBackedPaymentsComponent, canActivate: [AuthGuard] },
	{ path: 'orders/spsls', component: SpslsComponent, canActivate: [AuthGuard] },
	//	{ path: 'dispatches/open-credit', component: CreditOpenListComponent, canActivate: [AuthGuard] },



	{ path: 'receivables/credit-invoice/:id', component: CreditFreestandingComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/credit-rma/:rma', component: CreditFreestandingComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/credit-note', component: CreditLoadComponent, canActivate: [AuthGuard] },
	//{ path: 'receivables/credit-note/:transno', component: CreditLoadComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/credit-finalize/:transno', component: FinalizeComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/credit-note/:debtor/:branch', component: CreditFreestandingComponent, canActivate: [AuthGuard] },
	{ path: 'education/education-events', component: EducationEventsComponent, canActivate: [AuthGuard] },
	{ path: 'education/education-locations', component: EducationLocationsComponent, canActivate: [AuthGuard] },
	{ path: 'education/education-rewards', component: EducationRewardsComponent, canActivate: [AuthGuard] },
	{ path: 'education/education-numbers', component: EducationNumbersComponent, canActivate: [AuthGuard] },
	{ path: 'education/attendees', component: AttendeesComponent, canActivate: [AuthGuard] },
	{ path: 'education/voucher-report', component: VoucherReportComponent, canActivate: [AuthGuard] },

	{ path: 'orders/create-credit-note', component: CreditLoadComponent, canActivate: [AuthGuard] },

	{ path: 'orders/create-credit-note/:debtor/:branch', component: CreditLoadComponent, canActivate: [AuthGuard] },

	{ path: 'counter-pos/create-credit-note', component: CreditLoadComponent, canActivate: [AuthGuard] },
	{ path: 'credits/open-credits', component: OpenCreditListComponent, canActivate: [AuthGuard] },
	{ path: 'credits/rma-log', component: RmaLogComponent, canActivate: [AuthGuard] },
	{ path: 'dispatches/open-credits', component: OpenCreditListComponent, canActivate: [AuthGuard] },

	{ path: 'receivables/dispatch', component: CreditDispatchComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/dispatch/:transno', component: CreditDispatchComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/dispatch/:transno/pos', component: CreditDispatchComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/success', component: CreditSuccessComponent, canActivate: [AuthGuard] },
	{ path: 'receivables/success/:transno', component: CreditSuccessComponent, canActivate: [AuthGuard] },

	//fixed assets


	{ path: 'fixed-assets/fixed-assets-management', component: FixedAssetsManagementComponent, canActivate: [AuthGuard] },

	{ path: 'receivables/dashboard', component: ReceivablesDashboardComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/account-inquiry', component: AccountInquiryComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/document-lookup', component: DocumentLookupComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/trial-balance', component: TrialBalanceComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/simple-trial-balance', component: SimpleTrialBalanceComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/sales-ledger-control', component: SalesLedgerControlCheckComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/profit-and-loss', component: ProfitLossComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/shield-compliance', component: ShieldComplianceComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/expense-by-department', component: ExpenseByDepartmentComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/tax-authority-report', component: TaxAuthorityReportComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/third-party-sales-gl', component: ThirdPartySalesGlReportComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/balance-sheet', component: BalanceSheetComponent, canActivate: [AuthGuard] },
	//{ path: 'general-ledger/sales-taxes', component: SalesTaxComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/sales-taxes', component: SalesTaxCompressedComponent, canActivate: [AuthGuard] },
	{ path: 'customers/salon-prospects', component: BeauticianProspectingComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/bank-rec', component: BankRecComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/sales-taxes-compressed', component: SalesTaxCompressedComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/budgets', component: GlBudgetsComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/tags', component: GLTagsComponent, canActivate: [AuthGuard] },

	{ path: 'general-ledger/general-posting-setup', component: GeneralPostingSetupComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/sales-gl-postings', component: SalesGLPostingsComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/cogs-gl-postings', component: CogsGlPostingsComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/inventory-gl-postings', component: InventoryGlPostingsComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/gl-close-control', component: GlCloseControlComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/department-required', component: GlDepartmentRequiredComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/gl-impact', component: GlImpactViewComponent, canActivate: [AuthGuard] },

	{ path: 'general-ledger/journal-entry', component: JournalEntryComponent, canActivate: [AuthGuard] },
	{ path: 'general-ledger/journal-inquiry', component: JournalInquiryComponent, canActivate: [AuthGuard] },

	{ path: 'users-list', component: UsersComponent, canActivate: [AuthGuard] },
	{ path: 'users/edit/:id', component: UserEditComponent, canActivate: [AuthGuard] },
	{ path: 'users/create', component: UserCreateComponent, canActivate: [AuthGuard] },
	{ path: 'users/salesperson-app-users', component: SalesmanAppUsersComponent, canActivate: [AuthGuard] },
	{ path: 'users/vendors', component: UsersVendorsComponent, canActivate: [AuthGuard] },

	{ path: 'users/favorites', component: FavoritesComponent, canActivate: [AuthGuard] },

	{ path: 'users/user-profile', component: UserProfileComponent, canActivate: [AuthGuard] },
	{ path: 'users/user-settings', component: UserSettingsComponent, canActivate: [AuthGuard] },
	{ path: 'usergroups', component: UserGroupsComponent, canActivate: [AuthGuard] },
	{ path: 'usergroups/edit/:id', component: UserGroupsEditComponent, canActivate: [AuthGuard] },

	/* company */
	{ path: 'system/company', component: CompanySetupComponent, canActivate: [AuthGuard] },
	{ path: 'system/taxes', component: TaxesComponent, canActivate: [AuthGuard] },
	{ path: 'system/currencies', component: CurrenciesComponent, canActivate: [AuthGuard] },

	{ path: 'system/coupons', component: CouponSetupComponent, canActivate: [AuthGuard] },
	{ path: 'system/marketing', component: MarketingComponent, canActivate: [AuthGuard] },

	{ path: 'system/settings', component: CompanySetupComponent, canActivate: [AuthGuard] },
	{ path: 'system/inventory-settings', component: InventorySettingsComponent, canActivate: [AuthGuard] },
	{ path: 'system/customer-groups', component: CustomerGroupsComponent, canActivate: [AuthGuard] },
	{ path: 'system/product-groups', component: ProductGroupsComponent, canActivate: [AuthGuard] },
	{ path: 'system/report-builder', component: ReportBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'system/sale-builder', component: SaleBuilderComponent, canActivate: [AuthGuard] },
	{ path: 'system/move-transactions', component: MoveTransactionComponent, canActivate: [AuthGuard] },
	{ path: 'system/move-vendor-transactions', component: MoveVendorTransactionComponent, canActivate: [AuthGuard] },
	{ path: 'system/form-builder', component: FormBuilderComponent, canActivate: [AuthGuard] },


	{ path: 'system/merge-customers', component: MergeCustomersComponent, canActivate: [AuthGuard] },
	{ path: 'system/matrix-copy', component: MatrixCopyComponent, canActivate: [AuthGuard] },
	{ path: 'system/matrix-brands', component: MatrixBrandsComponent, canActivate: [AuthGuard] },
	{ path: 'system/brand-storefronts', component: BrandStorefrontsComponent, canActivate: [AuthGuard] },
	{ path: 'system/api-settings', component: ApiSettingsComponent, canActivate: [AuthGuard] },
	{
		path: 'tpl3pl',
		component: Tpl3plLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
			{ path: 'dashboard', component: Tpl3plDashboardComponent },
			{ path: 'config', component: Tpl3plConfigFormComponent },
			{ path: 'export-queue', component: Tpl3plExportQueueComponent },
			{ path: 'inbound', component: Tpl3plInboundComponent },
			{ path: 'open-orders', component: Tpl3plOpenOrdersComponent },
			{ path: 'shipments', component: Tpl3plShipmentsComponent },
			{ path: 'capture-auths', component: Tpl3plCaptureAuthsComponent },
			{ path: 'void-auths', component: Tpl3plVoidAuthsComponent },
			{ path: 'inventory', component: Tpl3plInventoryComponent },
			{ path: 'manual-sku-push', component: Tpl3plManualSkuPushComponent },
			{ path: 'logs', component: Tpl3plLogsComponent },

		]
	},
	{
		path: 'storefront',
		component: StorefrontLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: '', redirectTo: 'banners', pathMatch: 'full' },
			{ path: 'banners', component: BannersComponent },
			{ path: 'basic-settings', redirectTo: 'banners', pathMatch: 'full' },
			{ path: 'categories', component: CategoriesComponent },
			{ path: 'customer-approval', component: CustomerApprovalComponent },
			{ path: 'information', component: InformationComponent },
			{ path: 'qr-codes', component: QrCodesComponent },
			{ path: 'bestsellers', component: BestsellersComponent }
		]
	},
	{ path: 'system/gl-accounts', component: GlAccountsComponent, canActivate: [AuthGuard] },
	{ path: 'system/email', component: MailComponent, canActivate: [AuthGuard] },
	{ path: 'system/gl-accounts/account-sections', component: AccountSectionsComponent, canActivate: [AuthGuard] },
	{ path: 'system/gl-accounts/account-sections/:id', component: AccountSectionsComponent, canActivate: [AuthGuard] },
	{ path: 'system/gl-accounts/account-groups', component: AccountGroupsComponent, canActivate: [AuthGuard] },
	{ path: 'system/gl-accounts/account-groups/:id', component: AccountGroupsComponent, canActivate: [AuthGuard] },
	{ path: 'system/gl-accounts/:id', component: GlAccountsComponent, canActivate: [AuthGuard] },
	{ path: 'system/storefront-settings', component: StorefrontSettingsComponent, canActivate: [AuthGuard] },
	{ path: 'system/system-notice', component: SystemNoticeComponent, canActivate: [AuthGuard] },
	{ path: 'system/scheduler', loadChildren: () => import('../system/scheduler/scheduler.module').then(m => m.SchedulerModule), canActivate: [AuthGuard] },

	{ path: 'system/shipvia', component: ShippingMethodsComponent, canActivate: [AuthGuard] },

	{ path: 'system/sales-areas', component: SalesAreasComponent, canActivate: [AuthGuard] },

	{ path: 'system/bank-accounts', component: BankAccountsComponent, canActivate: [AuthGuard] },

	{ path: 'system/types', component: SystemTypesViewComponent, canActivate: [AuthGuard] },
	{ path: 'system/status-maintenance', component: StatusMaintenanceComponent, canActivate: [AuthGuard] },
	{ path: 'system/inventory-locations', component: InventoryLocationsComponent, canActivate: [AuthGuard] },
	{ path: 'system/inventory-locations/create/:id', component: InventoryLocationsCreateComponent, canActivate: [AuthGuard] },
	// { path: 'fileupload',	 component: FileuploadComponent },
	{ path: 'auth/permission', component: PermissionComponent },
	{ path: 'logout', component: LogoutComponent },

	// CRM Routes
	//{ path: 'crm', loadChildren: () => import('../crm/crm.module').then(m => m.CrmModule), canActivate: [AuthGuard] },

	// Design Control Routes
	{ path: 'design-control', loadChildren: () => import('../design-control/design-control.module').then(m => m.DesignControlModule), canActivate: [AuthGuard] },

	// Metrc (cannabis track-and-trace) Routes
	{ path: 'metrc', loadChildren: () => import('../metrc/metrc.module').then(m => m.MetrcModule), canActivate: [AuthGuard] },

	// Route Builder v2 (RB2 lazy module — feature-flag gated; runs side-by-side with v1)
	{ path: 'route-builder-v2', loadChildren: () => import('../route-builder-v2/route-builder-v2.module').then(m => m.RouteBuilderV2Module), canActivate: [AuthGuard] },

];

/**
 * Every path explicitly declared in ROUTES (parents + children at all levels).
 * Used by menuPathExplicitOrImplied to prevent the prefix match from granting
 * named child pages (e.g. /customers/dashboard) just because a parent path
 * (/customers) is stored in access_permissions.  Dynamic route segments like
 * /metrc/pick/12345 are NOT in this set, so they still pass via prefix match.
 */
function buildKnownMenuPaths(routes: RouteInfo[]): Set<string> {
	const paths = new Set<string>();
	for (const r of routes) {
		if (r.path) {paths.add(r.path);}
		if (r.reports) {
			for (const rep of r.reports) {
				if (rep.path) {paths.add(rep.path);}
			}
		}
		if (r.children) {
			for (const c of r.children) {
				if (c.path) {paths.add(c.path);}
				if (c.reports) {
					for (const rep of c.reports) {
						if (rep.path) {paths.add(rep.path);}
					}
				}
				if (c.children) {
					for (const g of c.children) {
						if (g.path) {paths.add(g.path);}
						if (g.reports) {
							for (const rep of g.reports) {
								if (rep.path) {paths.add(rep.path);}
							}
						}
					}
				}
			}
		}
	}
	return paths;
}
export const KNOWN_MENU_PATHS: Set<string> = buildKnownMenuPaths(ROUTES);
